const Data = [
  {
    index: 0,
    pathway: '2-Oxocarboxylic acid metabolism',
    totalNumberPapers: '19',
    adSpecificPaperCount: '11',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '3.3913',
    literatureRank: '216',
    adSpecificPaperRank: '209',
    prcPapersAd: '48%',
    perDementia: '43%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '10%',
    perModel: '35%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '50%',
    perAnimal: '25%',
    perHuman: '50%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 1,
    pathway: 'ABC transporters',
    totalNumberPapers: '432',
    adSpecificPaperCount: '380',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '11.287',
    literatureRank: '89',
    adSpecificPaperRank: '81',
    prcPapersAd: '88%',
    perDementia: '7%',
    perRelatedDementia: '4%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '36%',
    perGenetic: '47%',
    perModel: '40%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '5%',
    perAnimal: '23%',
    perHuman: '62%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 2,
    pathway: 'Acute myeloid leukemia',
    totalNumberPapers: '233',
    adSpecificPaperCount: '140',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '4.69231',
    literatureRank: '112',
    adSpecificPaperRank: '127',
    prcPapersAd: '60%',
    perDementia: '24%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '7%',
    perPapersUsingFullPathwayName: '11%',
    perGenetic: '33%',
    perModel: '43%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '14%',
    perAnimal: '22%',
    perHuman: '66%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 3,
    pathway: 'Adaptive immune system',
    totalNumberPapers: '328',
    adSpecificPaperCount: '134',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '4.94225',
    literatureRank: '104',
    adSpecificPaperRank: '130',
    prcPapersAd: '41%',
    perDementia: '28%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '20%',
    perPapersUsingFullPathwayName: '87%',
    perGenetic: '17%',
    perModel: '59%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '18%',
    perAnimal: '21%',
    perHuman: '64%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 4,
    pathway: 'Adherens junction',
    totalNumberPapers: '25',
    adSpecificPaperCount: '14',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '2.8',
    literatureRank: '214',
    adSpecificPaperRank: '206',
    prcPapersAd: '56%',
    perDementia: '20%',
    perRelatedDementia: '24%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '9%',
    perModel: '74%',
    perBothModelGenetic: '17%',
    perNeitherModelGenetic: '0%',
    perAnimal: '22%',
    perHuman: '57%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '17%'
  },
  {
    index: 5,
    pathway: 'Adipocytokine signaling pathway',
    totalNumberPapers: '85',
    adSpecificPaperCount: '62',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '9.21176',
    literatureRank: '177',
    adSpecificPaperRank: '169',
    prcPapersAd: '73%',
    perDementia: '11%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '6%',
    perGenetic: '33%',
    perModel: '41%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '21%',
    perAnimal: '21%',
    perHuman: '67%',
    perBothHumanAnimal: '2%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 6,
    pathway: 'Adrenergic signaling in cardiomyocytes',
    totalNumberPapers: '899',
    adSpecificPaperCount: '605',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '6.43667',
    literatureRank: '53',
    adSpecificPaperRank: '58',
    prcPapersAd: '67%',
    perDementia: '14%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '3%',
    perGenetic: '12%',
    perModel: '66%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '18%',
    perAnimal: '34%',
    perHuman: '50%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 7,
    pathway: 'African trypanosomiasis',
    totalNumberPapers: '12',
    adSpecificPaperCount: '5',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '1',
    literatureRank: '224',
    adSpecificPaperRank: '214',
    prcPapersAd: '42%',
    perDementia: '42%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '33%',
    perGenetic: '33%',
    perModel: '22%',
    perBothModelGenetic: '33%',
    perNeitherModelGenetic: '11%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 8,
    pathway: 'AGE-RAGE signaling pathway in diabetic complications',
    totalNumberPapers: '677',
    adSpecificPaperCount: '568',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '10.1758',
    literatureRank: '66',
    adSpecificPaperRank: '60',
    prcPapersAd: '84%',
    perDementia: '8%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '5%',
    perGenetic: '13%',
    perModel: '70%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '11%',
    perAnimal: '30%',
    perHuman: '47%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 9,
    pathway: 'Alanine aspartate and glutamate metabolism',
    totalNumberPapers: '3553',
    adSpecificPaperCount: '2572',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '7.9803',
    literatureRank: '15',
    adSpecificPaperRank: '13',
    prcPapersAd: '72%',
    perDementia: '14%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '9%',
    perModel: '74%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '12%',
    perAnimal: '37%',
    perHuman: '41%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 10,
    pathway: 'Alcoholism',
    totalNumberPapers: '2384',
    adSpecificPaperCount: '964',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '4.32859',
    literatureRank: '22',
    adSpecificPaperRank: '33',
    prcPapersAd: '40%',
    perDementia: '42%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '34%',
    perGenetic: '42%',
    perModel: '23%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '31%',
    perAnimal: '10%',
    perHuman: '79%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 11,
    pathway: 'Aldosterone synthesis and secretion',
    totalNumberPapers: '55',
    adSpecificPaperCount: '25',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '3.67273',
    literatureRank: '193',
    adSpecificPaperRank: '196',
    prcPapersAd: '45%',
    perDementia: '27%',
    perRelatedDementia: '27%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '36%',
    perModel: '43%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '21%',
    perAnimal: '12%',
    perHuman: '67%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '17%'
  },
  {
    index: 12,
    pathway: 'Aldosterone-regulated sodium reabsorption',
    totalNumberPapers: '57',
    adSpecificPaperCount: '25',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '3.47368',
    literatureRank: '193',
    adSpecificPaperRank: '196',
    prcPapersAd: '44%',
    perDementia: '26%',
    perRelatedDementia: '28%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '36%',
    perModel: '43%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '21%',
    perAnimal: '12%',
    perHuman: '67%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '17%'
  },
  {
    index: 13,
    pathway: 'Allograft rejection',
    totalNumberPapers: '45',
    adSpecificPaperCount: '16',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '4.38298',
    literatureRank: '200',
    adSpecificPaperRank: '204',
    prcPapersAd: '35%',
    perDementia: '39%',
    perRelatedDementia: '20%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '29%',
    perModel: '53%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '12%',
    perAnimal: '29%',
    perHuman: '47%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 14,
    pathway: 'alpha-Linolenic acid metabolism',
    totalNumberPapers: '62',
    adSpecificPaperCount: '35',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '6.51562',
    literatureRank: '190',
    adSpecificPaperRank: '186',
    prcPapersAd: '55%',
    perDementia: '31%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '25%',
    perModel: '51%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '17%',
    perAnimal: '15%',
    perHuman: '64%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 15,
    pathway: 'Alzheimer disease',
    totalNumberPapers: '130635',
    adSpecificPaperCount: '123510',
    pathwayScore: 'high',
    adPathwayScore: '1.2',
    adWordScore: '11.6108',
    literatureRank: '1',
    adSpecificPaperRank: '1',
    prcPapersAd: '95%',
    perDementia: '2%',
    perRelatedDementia: '3%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '24%',
    perModel: '44%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '27%',
    perAnimal: '20%',
    perHuman: '63%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 16,
    pathway: 'Amino sugar and nucleotide sugar metabolism',
    totalNumberPapers: '0',
    adSpecificPaperCount: '0',
    pathwayScore: 'high',
    adPathwayScore: 'NA',
    adWordScore: '0',
    literatureRank: '235',
    adSpecificPaperRank: '217',
    prcPapersAd: '0%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '0%',
    perModel: '100%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 17,
    pathway: 'Aminoacyl-tRNA biosynthesis',
    totalNumberPapers: '88',
    adSpecificPaperCount: '50',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '5.1978',
    literatureRank: '175',
    adSpecificPaperRank: '175',
    prcPapersAd: '55%',
    perDementia: '33%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '65%',
    perModel: '23%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '6%',
    perAnimal: '16%',
    perHuman: '68%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 18,
    pathway: 'Amoebiasis',
    totalNumberPapers: '0',
    adSpecificPaperCount: '0',
    pathwayScore: 'NA',
    adPathwayScore: 'NA',
    adWordScore: '0',
    literatureRank: '237',
    adSpecificPaperRank: '219',
    prcPapersAd: '0%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  },
  {
    index: 19,
    pathway: 'Amphetamine addiction',
    totalNumberPapers: '248',
    adSpecificPaperCount: '130',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '3.60241',
    literatureRank: '120',
    adSpecificPaperRank: '133',
    prcPapersAd: '52%',
    perDementia: '26%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '7%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '11%',
    perModel: '67%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '17%',
    perAnimal: '40%',
    perHuman: '45%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 20,
    pathway: 'AMPK signaling pathway',
    totalNumberPapers: '260',
    adSpecificPaperCount: '216',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '10.5308',
    literatureRank: '117',
    adSpecificPaperRank: '103',
    prcPapersAd: '83%',
    perDementia: '7%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '28%',
    perGenetic: '10%',
    perModel: '82%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '5%',
    perAnimal: '46%',
    perHuman: '30%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 21,
    pathway: 'Amyotrophic lateral sclerosis (ALS)',
    totalNumberPapers: '4682',
    adSpecificPaperCount: '1073',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '3.61085',
    literatureRank: '10',
    adSpecificPaperRank: '29',
    prcPapersAd: '23%',
    perDementia: '29%',
    perRelatedDementia: '46%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '26%',
    perModel: '59%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '5%',
    perAnimal: '14%',
    perHuman: '68%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 22,
    pathway: 'Antifolate resistance',
    totalNumberPapers: '1',
    adSpecificPaperCount: '1',
    pathwayScore: 'good',
    adPathwayScore: '5',
    adWordScore: '1',
    literatureRank: '236',
    adSpecificPaperRank: '218',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  },
  {
    index: 23,
    pathway: 'Antigen processing and presentation',
    totalNumberPapers: '415',
    adSpecificPaperCount: '304',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '8.24163',
    literatureRank: '91',
    adSpecificPaperRank: '92',
    prcPapersAd: '73%',
    perDementia: '12%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '9%',
    perGenetic: '18%',
    perModel: '65%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '7%',
    perAnimal: '24%',
    perHuman: '58%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 24,
    pathway: 'Apelin signaling pathway',
    totalNumberPapers: '2',
    adSpecificPaperCount: '2',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '12',
    literatureRank: '235',
    adSpecificPaperRank: '217',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '50%',
    perGenetic: '0%',
    perModel: '100%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '100%',
    perHuman: '0%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 25,
    pathway: 'Apoptosis',
    totalNumberPapers: '5982',
    adSpecificPaperCount: '4390',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '8.81996',
    literatureRank: '8',
    adSpecificPaperRank: '6',
    prcPapersAd: '73%',
    perDementia: '11%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '12%',
    perModel: '76%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '3%',
    perAnimal: '39%',
    perHuman: '37%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 26,
    pathway: 'Arachidonic acid metabolism',
    totalNumberPapers: '365',
    adSpecificPaperCount: '277',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '6.85519',
    literatureRank: '96',
    adSpecificPaperRank: '96',
    prcPapersAd: '76%',
    perDementia: '13%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '40%',
    perGenetic: '12%',
    perModel: '69%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '14%',
    perAnimal: '29%',
    perHuman: '49%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 27,
    pathway: 'Arginine and proline metabolism',
    totalNumberPapers: '493',
    adSpecificPaperCount: '383',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '9.46045',
    literatureRank: '80',
    adSpecificPaperRank: '80',
    prcPapersAd: '78%',
    perDementia: '9%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '17%',
    perModel: '59%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '19%',
    perAnimal: '26%',
    perHuman: '48%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 28,
    pathway: 'Arginine biosynthesis',
    totalNumberPapers: '281',
    adSpecificPaperCount: '196',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.65957',
    literatureRank: '110',
    adSpecificPaperRank: '108',
    prcPapersAd: '70%',
    perDementia: '12%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '22%',
    perGenetic: '17%',
    perModel: '56%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '23%',
    perAnimal: '30%',
    perHuman: '50%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 29,
    pathway: 'Arrhythmogenic right ventricular cardiomyopathy (ARVC)',
    totalNumberPapers: '92',
    adSpecificPaperCount: '23',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.41935',
    literatureRank: '158',
    adSpecificPaperRank: '198',
    prcPapersAd: '25%',
    perDementia: '42%',
    perRelatedDementia: '28%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '14%',
    perGenetic: '50%',
    perModel: '18%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '26%',
    perAnimal: '13%',
    perHuman: '75%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 30,
    pathway: 'Ascorbate and aldarate metabolism',
    totalNumberPapers: '472',
    adSpecificPaperCount: '238',
    pathwayScore: 'good',
    adPathwayScore: '3.66667',
    adWordScore: '7.60955',
    literatureRank: '84',
    adSpecificPaperRank: '100',
    prcPapersAd: '67%',
    perDementia: '19%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '75%',
    perGenetic: '22%',
    perModel: '58%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '14%',
    perAnimal: '33%',
    perHuman: '49%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 31,
    pathway: 'Asthma',
    totalNumberPapers: '347',
    adSpecificPaperCount: '153',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '2.54131',
    literatureRank: '98',
    adSpecificPaperRank: '119',
    prcPapersAd: '44%',
    perDementia: '42%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '39%',
    perModel: '28%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '26%',
    perAnimal: '15%',
    perHuman: '71%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 32,
    pathway: 'Autoimmune thyroid disease',
    totalNumberPapers: '87',
    adSpecificPaperCount: '35',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '4.5977',
    literatureRank: '176',
    adSpecificPaperRank: '186',
    prcPapersAd: '40%',
    perDementia: '41%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '55%',
    perModel: '4%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '38%',
    perAnimal: '1%',
    perHuman: '95%',
    perBothHumanAnimal: '1%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 33,
    pathway: 'Autophagy',
    totalNumberPapers: '1248',
    adSpecificPaperCount: '773',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '9.03846',
    literatureRank: '40',
    adSpecificPaperRank: '48',
    prcPapersAd: '62%',
    perDementia: '13%',
    perRelatedDementia: '24%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '13%',
    perModel: '74%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '5%',
    perAnimal: '41%',
    perHuman: '34%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 34,
    pathway: 'Axon guidance',
    totalNumberPapers: '144',
    adSpecificPaperCount: '114',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '6.80556',
    literatureRank: '153',
    adSpecificPaperRank: '141',
    prcPapersAd: '79%',
    perDementia: '12%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '79%',
    perGenetic: '19%',
    perModel: '74%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '2%',
    perAnimal: '43%',
    perHuman: '35%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 35,
    pathway: 'B cell receptor signaling pathway',
    totalNumberPapers: '220',
    adSpecificPaperCount: '151',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '9.18468',
    literatureRank: '126',
    adSpecificPaperRank: '121',
    prcPapersAd: '68%',
    perDementia: '16%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '22%',
    perGenetic: '16%',
    perModel: '58%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '13%',
    perAnimal: '36%',
    perHuman: '45%',
    perBothHumanAnimal: '15%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 36,
    pathway: 'Bacterial invasion of epithelial cells',
    totalNumberPapers: '6',
    adSpecificPaperCount: '5',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '6.83333',
    literatureRank: '230',
    adSpecificPaperRank: '214',
    prcPapersAd: '83%',
    perDementia: '0%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '0%',
    perModel: '50%',
    perBothModelGenetic: '50%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 37,
    pathway: 'Basal cell carcinoma',
    totalNumberPapers: '8',
    adSpecificPaperCount: '4',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '6.125',
    literatureRank: '229',
    adSpecificPaperRank: '215',
    prcPapersAd: '50%',
    perDementia: '38%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '67%',
    perModel: '17%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '17%',
    perAnimal: '0%',
    perHuman: '83%',
    perBothHumanAnimal: '17%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 38,
    pathway: 'Basal transcription factors',
    totalNumberPapers: '1628',
    adSpecificPaperCount: '1181',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '8.04782',
    literatureRank: '28',
    adSpecificPaperRank: '25',
    prcPapersAd: '72%',
    perDementia: '13%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '6%',
    perGenetic: '29%',
    perModel: '54%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '2%',
    perAnimal: '33%',
    perHuman: '47%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 39,
    pathway: 'Base excision repair',
    totalNumberPapers: '61',
    adSpecificPaperCount: '42',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '8.33871',
    literatureRank: '192',
    adSpecificPaperRank: '180',
    prcPapersAd: '68%',
    perDementia: '16%',
    perRelatedDementia: '16%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '61%',
    perModel: '20%',
    perBothModelGenetic: '20%',
    perNeitherModelGenetic: '0%',
    perAnimal: '14%',
    perHuman: '67%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 40,
    pathway: 'beta-Alanine metabolism',
    totalNumberPapers: '273',
    adSpecificPaperCount: '174',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '5.25091',
    literatureRank: '113',
    adSpecificPaperRank: '113',
    prcPapersAd: '63%',
    perDementia: '24%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '14%',
    perModel: '57%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '24%',
    perAnimal: '32%',
    perHuman: '46%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 41,
    pathway: 'Bile secretion',
    totalNumberPapers: '121',
    adSpecificPaperCount: '62',
    pathwayScore: 'good',
    adPathwayScore: '1',
    adWordScore: '3.66667',
    literatureRank: '162',
    adSpecificPaperRank: '169',
    prcPapersAd: '50%',
    perDementia: '32%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '7%',
    perGenetic: '30%',
    perModel: '46%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '19%',
    perAnimal: '22%',
    perHuman: '56%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 42,
    pathway: 'Biosynthesis of amino acids',
    totalNumberPapers: '95',
    adSpecificPaperCount: '64',
    pathwayScore: 'good',
    adPathwayScore: '2',
    adWordScore: '5.2551',
    literatureRank: '173',
    adSpecificPaperRank: '167',
    prcPapersAd: '65%',
    perDementia: '19%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '23%',
    perModel: '60%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '12%',
    perAnimal: '34%',
    perHuman: '47%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 43,
    pathway: 'Biosynthesis of unsaturated fatty acids',
    totalNumberPapers: '678',
    adSpecificPaperCount: '442',
    pathwayScore: 'good',
    adPathwayScore: '4.5',
    adWordScore: '7.11504',
    literatureRank: '65',
    adSpecificPaperRank: '69',
    prcPapersAd: '65%',
    perDementia: '21%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '10%',
    perGenetic: '23%',
    perModel: '53%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '17%',
    perAnimal: '30%',
    perHuman: '51%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 44,
    pathway: 'Biotin metabolism',
    totalNumberPapers: '6',
    adSpecificPaperCount: '5',
    pathwayScore: 'ok',
    adPathwayScore: '4',
    adWordScore: '5.16667',
    literatureRank: '215',
    adSpecificPaperRank: '214',
    prcPapersAd: '83%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '17%',
    perPapersUsingFullPathwayName: '16%',
    perGenetic: '5%',
    perModel: '77%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '9%',
    perAnimal: '27%',
    perHuman: '55%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 45,
    pathway: 'Bladder cancer',
    totalNumberPapers: '24',
    adSpecificPaperCount: '14',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '1.43333',
    literatureRank: '210',
    adSpecificPaperRank: '206',
    prcPapersAd: '47%',
    perDementia: '33%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '7%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '54%',
    perModel: '13%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '33%',
    perAnimal: '4%',
    perHuman: '79%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 46,
    pathway: 'Breast cancer',
    totalNumberPapers: '665',
    adSpecificPaperCount: '298',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.82459',
    literatureRank: '69',
    adSpecificPaperRank: '93',
    prcPapersAd: '45%',
    perDementia: '39%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '52%',
    perModel: '24%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '18%',
    perAnimal: '7%',
    perHuman: '77%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 47,
    pathway: 'Butanoate metabolism',
    totalNumberPapers: '28',
    adSpecificPaperCount: '20',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '8.03571',
    literatureRank: '212',
    adSpecificPaperRank: '201',
    prcPapersAd: '71%',
    perDementia: '18%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '21%',
    perGenetic: '12%',
    perModel: '73%',
    perBothModelGenetic: '12%',
    perNeitherModelGenetic: '4%',
    perAnimal: '38%',
    perHuman: '38%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 48,
    pathway: 'Caffeine metabolism',
    totalNumberPapers: '218',
    adSpecificPaperCount: '129',
    pathwayScore: 'good',
    adPathwayScore: '2.5',
    adWordScore: '8.63761',
    literatureRank: '128',
    adSpecificPaperRank: '134',
    prcPapersAd: '59%',
    perDementia: '22%',
    perRelatedDementia: '19%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '22%',
    perModel: '57%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '18%',
    perAnimal: '34%',
    perHuman: '50%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 49,
    pathway: 'Calcium signaling pathway',
    totalNumberPapers: '3811',
    adSpecificPaperCount: '2775',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.14904',
    literatureRank: '13',
    adSpecificPaperRank: '11',
    prcPapersAd: '73%',
    perDementia: '13%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '22%',
    perGenetic: '16%',
    perModel: '70%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '9%',
    perAnimal: '32%',
    perHuman: '46%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 50,
    pathway: 'cAMP signaling pathway',
    totalNumberPapers: '805',
    adSpecificPaperCount: '647',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '9.67702',
    literatureRank: '61',
    adSpecificPaperRank: '54',
    prcPapersAd: '80%',
    perDementia: '10%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '39%',
    perGenetic: '12%',
    perModel: '73%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '8%',
    perAnimal: '44%',
    perHuman: '34%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 51,
    pathway: 'Cancer',
    totalNumberPapers: '5961',
    adSpecificPaperCount: '2935',
    pathwayScore: 'high',
    adPathwayScore: '5',
    adWordScore: '3.51921',
    literatureRank: '9',
    adSpecificPaperRank: '9',
    prcPapersAd: '49%',
    perDementia: '37%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '37%',
    perModel: '34%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '21%',
    perAnimal: '15%',
    perHuman: '65%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 52,
    pathway: 'Carbohydrate digestion and absorption',
    totalNumberPapers: '12',
    adSpecificPaperCount: '11',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '4.64706',
    literatureRank: '220',
    adSpecificPaperRank: '209',
    prcPapersAd: '65%',
    perDementia: '24%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '17%',
    perGenetic: '29%',
    perModel: '50%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '14%',
    perAnimal: '43%',
    perHuman: '43%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 53,
    pathway: 'Carbon metabolism',
    totalNumberPapers: '135',
    adSpecificPaperCount: '79',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '6.26667',
    literatureRank: '157',
    adSpecificPaperRank: '160',
    prcPapersAd: '59%',
    perDementia: '26%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '30%',
    perModel: '50%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '10%',
    perAnimal: '31%',
    perHuman: '52%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 54,
    pathway: 'Cardiac muscle contraction',
    totalNumberPapers: '48',
    adSpecificPaperCount: '17',
    pathwayScore: 'good',
    adPathwayScore: '2',
    adWordScore: '3.60417',
    literatureRank: '199',
    adSpecificPaperRank: '203',
    prcPapersAd: '35%',
    perDementia: '27%',
    perRelatedDementia: '35%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '67%',
    perGenetic: '13%',
    perModel: '55%',
    perBothModelGenetic: '16%',
    perNeitherModelGenetic: '16%',
    perAnimal: '58%',
    perHuman: '29%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 55,
    pathway: 'Cell adhesion molecules (CAMs)',
    totalNumberPapers: '395',
    adSpecificPaperCount: '252',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '7.13131',
    literatureRank: '93',
    adSpecificPaperRank: '99',
    prcPapersAd: '64%',
    perDementia: '13%',
    perRelatedDementia: '19%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '55%',
    perGenetic: '19%',
    perModel: '68%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '4%',
    perAnimal: '25%',
    perHuman: '56%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 56,
    pathway: 'Cell cycle',
    totalNumberPapers: '1006',
    adSpecificPaperCount: '803',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '8.0159',
    literatureRank: '50',
    adSpecificPaperRank: '44',
    prcPapersAd: '80%',
    perDementia: '11%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '24%',
    perModel: '60%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '3%',
    perAnimal: '26%',
    perHuman: '48%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 57,
    pathway: 'Cellular senescence',
    totalNumberPapers: '1078',
    adSpecificPaperCount: '767',
    pathwayScore: 'good',
    adPathwayScore: '2',
    adWordScore: '9.57739',
    literatureRank: '46',
    adSpecificPaperRank: '49',
    prcPapersAd: '71%',
    perDementia: '20%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '51%',
    perGenetic: '16%',
    perModel: '68%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '9%',
    perAnimal: '45%',
    perHuman: '42%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 58,
    pathway: 'Central carbon metabolism in cancer',
    totalNumberPapers: '64',
    adSpecificPaperCount: '40',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '7.04688',
    literatureRank: '190',
    adSpecificPaperRank: '182',
    prcPapersAd: '63%',
    perDementia: '28%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '14%',
    perGenetic: '55%',
    perModel: '28%',
    perBothModelGenetic: '15%',
    perNeitherModelGenetic: '2%',
    perAnimal: '23%',
    perHuman: '62%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 59,
    pathway: 'cGMP-PKG signaling pathway',
    totalNumberPapers: '190',
    adSpecificPaperCount: '137',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '8.1466',
    literatureRank: '138',
    adSpecificPaperRank: '128',
    prcPapersAd: '72%',
    perDementia: '14%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '8%',
    perModel: '77%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '9%',
    perAnimal: '41%',
    perHuman: '37%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 60,
    pathway: 'Chagas disease (American trypanosomiasis)',
    totalNumberPapers: '23',
    adSpecificPaperCount: '9',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '1.17391',
    literatureRank: '216',
    adSpecificPaperRank: '211',
    prcPapersAd: '41%',
    perDementia: '41%',
    perRelatedDementia: '18%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '52%',
    perGenetic: '25%',
    perModel: '19%',
    perBothModelGenetic: '19%',
    perNeitherModelGenetic: '38%',
    perAnimal: '6%',
    perHuman: '81%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 61,
    pathway: 'Chemical carcinogenesis',
    totalNumberPapers: '217',
    adSpecificPaperCount: '120',
    pathwayScore: 'ok',
    adPathwayScore: '5',
    adWordScore: '3.36406',
    literatureRank: '129',
    adSpecificPaperRank: '138',
    prcPapersAd: '56%',
    perDementia: '29%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '41%',
    perGenetic: '35%',
    perModel: '44%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '11%',
    perAnimal: '32%',
    perHuman: '47%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 62,
    pathway: 'Chemokine signaling pathway',
    totalNumberPapers: '3957',
    adSpecificPaperCount: '2776',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '8.62472',
    literatureRank: '12',
    adSpecificPaperRank: '10',
    prcPapersAd: '71%',
    perDementia: '13%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '8%',
    perPapersUsingFullPathwayName: '17%',
    perGenetic: '15%',
    perModel: '71%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '9%',
    perAnimal: '34%',
    perHuman: '49%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 63,
    pathway: 'Cholesterol metabolism',
    totalNumberPapers: '3492',
    adSpecificPaperCount: '2538',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '9.54439',
    literatureRank: '17',
    adSpecificPaperRank: '14',
    prcPapersAd: '73%',
    perDementia: '13%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '32%',
    perGenetic: '39%',
    perModel: '41%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '12%',
    perAnimal: '20%',
    perHuman: '63%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 64,
    pathway: 'Choline metabolism in cancer',
    totalNumberPapers: '31',
    adSpecificPaperCount: '24',
    pathwayScore: 'high',
    adPathwayScore: '3.66667',
    adWordScore: '7.48387',
    literatureRank: '209',
    adSpecificPaperRank: '197',
    prcPapersAd: '77%',
    perDementia: '16%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '6%',
    perGenetic: '11%',
    perModel: '71%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '11%',
    perAnimal: '46%',
    perHuman: '25%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 65,
    pathway: 'Cholinergic synapse',
    totalNumberPapers: '11301',
    adSpecificPaperCount: '9236',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.64348',
    literatureRank: '6',
    adSpecificPaperRank: '4',
    prcPapersAd: '82%',
    perDementia: '8%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '3%',
    perGenetic: '9%',
    perModel: '64%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '23%',
    perAnimal: '34%',
    perHuman: '48%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 66,
    pathway: 'Chronic myeloid leukemia',
    totalNumberPapers: '210',
    adSpecificPaperCount: '123',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '4.47619',
    literatureRank: '112',
    adSpecificPaperRank: '135',
    prcPapersAd: '59%',
    perDementia: '27%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '33%',
    perModel: '43%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '14%',
    perAnimal: '21%',
    perHuman: '65%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 67,
    pathway: 'Circadian entrainment',
    totalNumberPapers: '178',
    adSpecificPaperCount: '119',
    pathwayScore: 'high',
    adPathwayScore: 'NA',
    adWordScore: '6.26404',
    literatureRank: '67',
    adSpecificPaperRank: '139',
    prcPapersAd: '67%',
    perDementia: '24%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '13%',
    perGenetic: '25%',
    perModel: '36%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '35%',
    perAnimal: '15%',
    perHuman: '71%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 68,
    pathway: 'Circadian rhythm',
    totalNumberPapers: '673',
    adSpecificPaperCount: '427',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '5.96137',
    literatureRank: '67',
    adSpecificPaperRank: '73',
    prcPapersAd: '64%',
    perDementia: '28%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '77%',
    perGenetic: '25%',
    perModel: '36%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '35%',
    perAnimal: '15%',
    perHuman: '71%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 69,
    pathway: 'Citrate cycle (TCA cycle)',
    totalNumberPapers: '216',
    adSpecificPaperCount: '164',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '6.80184',
    literatureRank: '129',
    adSpecificPaperRank: '115',
    prcPapersAd: '76%',
    perDementia: '17%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '61%',
    perGenetic: '13%',
    perModel: '70%',
    perBothModelGenetic: '2%',
    perNeitherModelGenetic: '15%',
    perAnimal: '41%',
    perHuman: '35%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 70,
    pathway: 'Cocaine addiction',
    totalNumberPapers: '221',
    adSpecificPaperCount: '120',
    pathwayScore: 'high',
    adPathwayScore: '4.33333',
    adWordScore: '2.86486',
    literatureRank: '126',
    adSpecificPaperRank: '138',
    prcPapersAd: '54%',
    perDementia: '23%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '13%',
    perPapersUsingFullPathwayName: '46%',
    perGenetic: '22%',
    perModel: '56%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '15%',
    perAnimal: '30%',
    perHuman: '58%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 71,
    pathway: 'Collecting duct acid secretion',
    totalNumberPapers: '0',
    adSpecificPaperCount: '0',
    pathwayScore: 'ok',
    adPathwayScore: 'NA',
    adWordScore: '0',
    literatureRank: '236',
    adSpecificPaperRank: '218',
    prcPapersAd: '0%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  },
  {
    index: 72,
    pathway: 'Colorectal cancer',
    totalNumberPapers: '384',
    adSpecificPaperCount: '152',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.09896',
    literatureRank: '92',
    adSpecificPaperRank: '120',
    prcPapersAd: '40%',
    perDementia: '45%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '47%',
    perModel: '25%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '20%',
    perAnimal: '11%',
    perHuman: '72%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 73,
    pathway: 'Complement and coagulation cascades',
    totalNumberPapers: '1104',
    adSpecificPaperCount: '796',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.44525',
    literatureRank: '45',
    adSpecificPaperRank: '45',
    prcPapersAd: '72%',
    perDementia: '17%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '29%',
    perModel: '48%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '18%',
    perAnimal: '18%',
    perHuman: '64%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 74,
    pathway: 'Cortisol synthesis and secretion',
    totalNumberPapers: '519',
    adSpecificPaperCount: '344',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '6.52216',
    literatureRank: '79',
    adSpecificPaperRank: '87',
    prcPapersAd: '66%',
    perDementia: '24%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '25%',
    perModel: '26%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '44%',
    perAnimal: '7%',
    perHuman: '88%',
    perBothHumanAnimal: '2%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 75,
    pathway: 'C-type lectin receptor signaling pathway',
    totalNumberPapers: '11',
    adSpecificPaperCount: '10',
    pathwayScore: 'high',
    adPathwayScore: '3.14286',
    adWordScore: '8.78571',
    literatureRank: '223',
    adSpecificPaperRank: '210',
    prcPapersAd: '71%',
    perDementia: '7%',
    perRelatedDementia: '21%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '33%',
    perModel: '50%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '8%',
    perAnimal: '25%',
    perHuman: '33%',
    perBothHumanAnimal: '25%',
    perNeitherHumanAnimal: '17%'
  },  
  {
    index: 76,
    pathway: 'Cushing syndrome',
    totalNumberPapers: '32',
    adSpecificPaperCount: '23',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '6.77143',
    literatureRank: '206',
    adSpecificPaperRank: '198',
    prcPapersAd: '66%',
    perDementia: '26%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '84%',
    perGenetic: '5%',
    perModel: '57%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '29%',
    perAnimal: '29%',
    perHuman: '67%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 77,
    pathway: 'Cysteine and methionine metabolism',
    totalNumberPapers: '948',
    adSpecificPaperCount: '624',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '7.31435',
    literatureRank: '52',
    adSpecificPaperRank: '57',
    prcPapersAd: '66%',
    perDementia: '18%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '21%',
    perModel: '59%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '12%',
    perAnimal: '30%',
    perHuman: '46%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 78,
    pathway: 'Cytokine signaling in immune system',
    totalNumberPapers: '428',
    adSpecificPaperCount: '293',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '8.92056',
    literatureRank: '90',
    adSpecificPaperRank: '95',
    prcPapersAd: '69%',
    perDementia: '18%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '8%',
    perGenetic: '7%',
    perModel: '82%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '1%',
    perAnimal: '48%',
    perHuman: '31%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 79,
    pathway: 'Cytokine-cytokine receptor interaction',
    totalNumberPapers: '1199',
    adSpecificPaperCount: '854',
    pathwayScore: 'ok',
    adPathwayScore: '3.5',
    adWordScore: '8.48959',
    literatureRank: '42',
    adSpecificPaperRank: '42',
    prcPapersAd: '72%',
    perDementia: '14%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '15%',
    perModel: '74%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '5%',
    perAnimal: '35%',
    perHuman: '44%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 80,
    pathway: 'Cytosolic DNA-sensing pathway',
    totalNumberPapers: '2',
    adSpecificPaperCount: '2',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '5',
    literatureRank: '232',
    adSpecificPaperRank: '217',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '50%',
    perGenetic: '67%',
    perModel: '33%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '67%',
    perHuman: '33%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 81,
    pathway: 'D-Arginine and D-ornithine metabolism',
    totalNumberPapers: '104',
    adSpecificPaperCount: '75',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '8.00943',
    literatureRank: '170',
    adSpecificPaperRank: '161',
    prcPapersAd: '71%',
    perDementia: '13%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '19%',
    perModel: '56%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '22%',
    perAnimal: '25%',
    perHuman: '61%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 82,
    pathway: 'D-Glutamine and D-glutamate metabolism',
    totalNumberPapers: '670',
    adSpecificPaperCount: '462',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '7.92399',
    literatureRank: '68',
    adSpecificPaperRank: '65',
    prcPapersAd: '69%',
    perDementia: '15%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '10%',
    perModel: '73%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '12%',
    perAnimal: '31%',
    perHuman: '49%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 83,
    pathway: 'Diabetes',
    totalNumberPapers: '6594',
    adSpecificPaperCount: '3208',
    pathwayScore: 'high',
    adPathwayScore: '5',
    adWordScore: '5.68653',
    literatureRank: '7',
    adSpecificPaperRank: '8',
    prcPapersAd: '49%',
    perDementia: '32%',
    perRelatedDementia: '19%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '44%',
    perModel: '31%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '18%',
    perAnimal: '15%',
    perHuman: '71%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 84,
    pathway: 'Dilated cardiomyopathy (DCM)',
    totalNumberPapers: '110',
    adSpecificPaperCount: '34',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.64545',
    literatureRank: '158',
    adSpecificPaperRank: '187',
    prcPapersAd: '31%',
    perDementia: '40%',
    perRelatedDementia: '24%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '27%',
    perGenetic: '50%',
    perModel: '18%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '26%',
    perAnimal: '13%',
    perHuman: '75%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 85,
    pathway: 'DNA replication',
    totalNumberPapers: '87',
    adSpecificPaperCount: '63',
    pathwayScore: 'high',
    adPathwayScore: '4.33333',
    adWordScore: '6.43678',
    literatureRank: '176',
    adSpecificPaperRank: '168',
    prcPapersAd: '72%',
    perDementia: '17%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '55%',
    perModel: '19%',
    perBothModelGenetic: '26%',
    perNeitherModelGenetic: '0%',
    perAnimal: '16%',
    perHuman: '56%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 86,
    pathway: 'Dopaminergic synapse',
    totalNumberPapers: '3539',
    adSpecificPaperCount: '1392',
    pathwayScore: 'high',
    adPathwayScore: '3.66667',
    adWordScore: '4.36448',
    literatureRank: '16',
    adSpecificPaperRank: '21',
    prcPapersAd: '39%',
    perDementia: '13%',
    perRelatedDementia: '46%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '19%',
    perModel: '54%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '22%',
    perAnimal: '24%',
    perHuman: '62%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 87,
    pathway: 'Drug metabolism',
    totalNumberPapers: '57',
    adSpecificPaperCount: '38',
    pathwayScore: 'ok',
    adPathwayScore: '4',
    adWordScore: '5.56897',
    literatureRank: '194',
    adSpecificPaperRank: '184',
    prcPapersAd: '66%',
    perDementia: '24%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '57%',
    perModel: '33%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '10%',
    perAnimal: '2%',
    perHuman: '83%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 88,
    pathway: 'ECM-receptor interaction',
    totalNumberPapers: '169',
    adSpecificPaperCount: '116',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '6.89535',
    literatureRank: '143',
    adSpecificPaperRank: '140',
    prcPapersAd: '67%',
    perDementia: '16%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '10%',
    perGenetic: '5%',
    perModel: '85%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '0%',
    perAnimal: '25%',
    perHuman: '48%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 89,
    pathway: 'EGFR tyrosine kinase inhibitor resistance',
    totalNumberPapers: '201',
    adSpecificPaperCount: '132',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '6.0297',
    literatureRank: '134',
    adSpecificPaperRank: '132',
    prcPapersAd: '66%',
    perDementia: '22%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '27%',
    perModel: '52%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '11%',
    perAnimal: '28%',
    perHuman: '53%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 90,
    pathway: 'Endocrine and other factor-regulated calcium reabsorption',
    totalNumberPapers: '2',
    adSpecificPaperCount: '0',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '0.5',
    literatureRank: '235',
    adSpecificPaperRank: '219',
    prcPapersAd: '0%',
    perDementia: '0%',
    perRelatedDementia: '50%',
    perUnrelatedDementia: '50%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  },
  {
    index: 91,
    pathway: 'Endocrine resistance',
    totalNumberPapers: '1',
    adSpecificPaperCount: '1',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '4',
    literatureRank: '231',
    adSpecificPaperRank: '218',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '33%',
    perModel: '33%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '33%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 92,
    pathway: 'Endocytosis',
    totalNumberPapers: '1234',
    adSpecificPaperCount: '1049',
    pathwayScore: 'high',
    adPathwayScore: '3.33333',
    adWordScore: '12.3538',
    literatureRank: '41',
    adSpecificPaperRank: '31',
    prcPapersAd: '85%',
    perDementia: '6%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '46%',
    perGenetic: '17%',
    perModel: '69%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '4%',
    perAnimal: '30%',
    perHuman: '40%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '20%'
  },
  {
    index: 93,
    pathway: 'Endometrial cancer',
    totalNumberPapers: '81',
    adSpecificPaperCount: '35',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.53659',
    literatureRank: '178',
    adSpecificPaperRank: '186',
    prcPapersAd: '43%',
    perDementia: '38%',
    perRelatedDementia: '18%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '53%',
    perModel: '30%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '13%',
    perAnimal: '8%',
    perHuman: '78%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 94,
    pathway: 'Epithelial cell signaling in Helicobacter pylori infection',
    totalNumberPapers: '75',
    adSpecificPaperCount: '41',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '5.54667',
    literatureRank: '183',
    adSpecificPaperRank: '181',
    prcPapersAd: '55%',
    perDementia: '29%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '30%',
    perModel: '25%',
    perBothModelGenetic: '2%',
    perNeitherModelGenetic: '44%',
    perAnimal: '16%',
    perHuman: '67%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 95,
    pathway: 'Epstein-Barr virus infection',
    totalNumberPapers: '58',
    adSpecificPaperCount: '32',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '5.92063',
    literatureRank: '191',
    adSpecificPaperRank: '189',
    prcPapersAd: '51%',
    perDementia: '22%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '13%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '49%',
    perModel: '35%',
    perBothModelGenetic: '2%',
    perNeitherModelGenetic: '15%',
    perAnimal: '0%',
    perHuman: '98%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '2%'
  },
  {
    index: 96,
    pathway: 'ErbB signaling pathway',
    totalNumberPapers: '209',
    adSpecificPaperCount: '141',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '6.40476',
    literatureRank: '131',
    adSpecificPaperRank: '126',
    prcPapersAd: '67%',
    perDementia: '23%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '37%',
    perGenetic: '37%',
    perModel: '43%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '10%',
    perAnimal: '26%',
    perHuman: '58%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 97,
    pathway: 'Estrogen signaling pathway',
    totalNumberPapers: '1825',
    adSpecificPaperCount: '1351',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '8.06521',
    literatureRank: '27',
    adSpecificPaperRank: '22',
    prcPapersAd: '74%',
    perDementia: '16%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '8%',
    perGenetic: '32%',
    perModel: '49%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '12%',
    perAnimal: '29%',
    perHuman: '55%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 98,
    pathway: 'Ether lipid metabolism',
    totalNumberPapers: '33',
    adSpecificPaperCount: '23',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '6.21212',
    literatureRank: '208',
    adSpecificPaperRank: '198',
    prcPapersAd: '70%',
    perDementia: '15%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '52%',
    perGenetic: '28%',
    perModel: '52%',
    perBothModelGenetic: '16%',
    perNeitherModelGenetic: '4%',
    perAnimal: '32%',
    perHuman: '48%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 99,
    pathway: 'Fanconi anemia pathway',
    totalNumberPapers: '5',
    adSpecificPaperCount: '2',
    pathwayScore: 'high',
    adPathwayScore: '3.75',
    adWordScore: '1.6',
    literatureRank: '232',
    adSpecificPaperRank: '217',
    prcPapersAd: '40%',
    perDementia: '0%',
    perRelatedDementia: '60%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '67%',
    perModel: '0%',
    perBothModelGenetic: '33%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '67%',
    perBothHumanAnimal: '33%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 100,
    pathway: 'Fat digestion and absorption',
    totalNumberPapers: '20',
    adSpecificPaperCount: '11',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '4.75',
    literatureRank: '219',
    adSpecificPaperRank: '209',
    prcPapersAd: '55%',
    perDementia: '40%',
    perRelatedDementia: '5%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '20%',
    perModel: '40%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '27%',
    perAnimal: '33%',
    perHuman: '40%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 101,
    pathway: 'Fatty acid biosynthesis',
    totalNumberPapers: '1337',
    adSpecificPaperCount: '926',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.2371',
    literatureRank: '35',
    adSpecificPaperRank: '38',
    prcPapersAd: '69%',
    perDementia: '18%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '16%',
    perGenetic: '24%',
    perModel: '52%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '18%',
    perAnimal: '28%',
    perHuman: '55%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 102,
    pathway: 'Fatty acid degradation',
    totalNumberPapers: '1234',
    adSpecificPaperCount: '863',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '7.44733',
    literatureRank: '34',
    adSpecificPaperRank: '40',
    prcPapersAd: '70%',
    perDementia: '17%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '5%',
    perGenetic: '24%',
    perModel: '53%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '17%',
    perAnimal: '28%',
    perHuman: '55%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 103,
    pathway: 'Fatty acid elongation',
    totalNumberPapers: '1195',
    adSpecificPaperCount: '836',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '7.38577',
    literatureRank: '34',
    adSpecificPaperRank: '43',
    prcPapersAd: '70%',
    perDementia: '17%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '24%',
    perModel: '53%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '17%',
    perAnimal: '28%',
    perHuman: '55%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 104,
    pathway: 'Fatty acid metabolism',
    totalNumberPapers: '1379',
    adSpecificPaperCount: '960',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '7.31617',
    literatureRank: '34',
    adSpecificPaperRank: '34',
    prcPapersAd: '70%',
    perDementia: '17%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '30%',
    perGenetic: '24%',
    perModel: '53%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '17%',
    perAnimal: '28%',
    perHuman: '55%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 105,
    pathway: 'Fc epsilon RI signaling pathway',
    totalNumberPapers: '2',
    adSpecificPaperCount: '1',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '11.5',
    literatureRank: '235',
    adSpecificPaperRank: '218',
    prcPapersAd: '50%',
    perDementia: '0%',
    perRelatedDementia: '50%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '100%',
    perModel: '0%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '100%',
    perHuman: '0%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 106,
    pathway: 'Fc gamma R-mediated phagocytosis',
    totalNumberPapers: '25',
    adSpecificPaperCount: '27',
    pathwayScore: 'high',
    adPathwayScore: '2.63636',
    adWordScore: '14.3871',
    literatureRank: '209',
    adSpecificPaperRank: '194',
    prcPapersAd: '87%',
    perDementia: '10%',
    perRelatedDementia: '3%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '16%',
    perGenetic: '8%',
    perModel: '83%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '0%',
    perAnimal: '38%',
    perHuman: '33%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '21%'
  },
  {
    index: 107,
    pathway: 'Ferroptosis',
    totalNumberPapers: '11',
    adSpecificPaperCount: '7',
    pathwayScore: 'high',
    adPathwayScore: '2.2',
    adWordScore: '7.45455',
    literatureRank: '224',
    adSpecificPaperRank: '212',
    prcPapersAd: '64%',
    perDementia: '18%',
    perRelatedDementia: '18%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '0%',
    perModel: '75%',
    perBothModelGenetic: '25%',
    perNeitherModelGenetic: '0%',
    perAnimal: '75%',
    perHuman: '25%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 108,
    pathway: 'Fluid shear stress and atherosclerosis',
    totalNumberPapers: '1578',
    adSpecificPaperCount: '793',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '4.87262',
    literatureRank: '30',
    adSpecificPaperRank: '46',
    prcPapersAd: '50%',
    perDementia: '25%',
    perRelatedDementia: '24%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '45%',
    perModel: '31%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '17%',
    perAnimal: '13%',
    perHuman: '71%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 109,
    pathway: 'Focal adhesion',
    totalNumberPapers: '476',
    adSpecificPaperCount: '375',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '8.28782',
    literatureRank: '83',
    adSpecificPaperRank: '82',
    prcPapersAd: '79%',
    perDementia: '8%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '16%',
    perGenetic: '22%',
    perModel: '62%',
    perBothModelGenetic: '12%',
    perNeitherModelGenetic: '4%',
    perAnimal: '28%',
    perHuman: '53%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 110,
    pathway: 'Folate biosynthesis',
    totalNumberPapers: '851',
    adSpecificPaperCount: '444',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '6.83705',
    literatureRank: '57',
    adSpecificPaperRank: '68',
    prcPapersAd: '52%',
    perDementia: '26%',
    perRelatedDementia: '20%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '7%',
    perGenetic: '49%',
    perModel: '19%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '25%',
    perAnimal: '12%',
    perHuman: '81%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 111,
    pathway: 'FoxO signaling pathway',
    totalNumberPapers: '156',
    adSpecificPaperCount: '96',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '7.89744',
    literatureRank: '149',
    adSpecificPaperRank: '149',
    prcPapersAd: '62%',
    perDementia: '21%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '37%',
    perGenetic: '19%',
    perModel: '66%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '1%',
    perAnimal: '39%',
    perHuman: '45%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 112,
    pathway: 'Fructose and mannose metabolism',
    totalNumberPapers: '132',
    adSpecificPaperCount: '99',
    pathwayScore: 'ok',
    adPathwayScore: '3.33333',
    adWordScore: '7.18519',
    literatureRank: '157',
    adSpecificPaperRank: '147',
    prcPapersAd: '74%',
    perDementia: '17%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '11%',
    perModel: '69%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '13%',
    perAnimal: '43%',
    perHuman: '36%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 113,
    pathway: 'GABAergic synapse',
    totalNumberPapers: '1164',
    adSpecificPaperCount: '877',
    pathwayScore: 'high',
    adPathwayScore: '3.66667',
    adWordScore: '7.47983',
    literatureRank: '44',
    adSpecificPaperRank: '39',
    prcPapersAd: '75%',
    perDementia: '11%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '6%',
    perGenetic: '7%',
    perModel: '77%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '11%',
    perAnimal: '40%',
    perHuman: '41%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 114,
    pathway: 'Galactose metabolism',
    totalNumberPapers: '395',
    adSpecificPaperCount: '341',
    pathwayScore: 'ok',
    adPathwayScore: '3',
    adWordScore: '10.9392',
    literatureRank: '94',
    adSpecificPaperRank: '88',
    prcPapersAd: '86%',
    perDementia: '7%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '11%',
    perGenetic: '2%',
    perModel: '94%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '2%',
    perAnimal: '86%',
    perHuman: '7%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '2%'
  },
  {
    index: 115,
    pathway: 'Gap junction',
    totalNumberPapers: '76',
    adSpecificPaperCount: '49',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '6.73684',
    literatureRank: '182',
    adSpecificPaperRank: '176',
    prcPapersAd: '64%',
    perDementia: '17%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '5%',
    perModel: '89%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '2%',
    perAnimal: '39%',
    perHuman: '34%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 116,
    pathway: 'Gastric acid secretion',
    totalNumberPapers: '14',
    adSpecificPaperCount: '5',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '1.93333',
    literatureRank: '222',
    adSpecificPaperRank: '214',
    prcPapersAd: '33%',
    perDementia: '47%',
    perRelatedDementia: '20%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '50%',
    perGenetic: '42%',
    perModel: '25%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '33%',
    perAnimal: '8%',
    perHuman: '67%',
    perBothHumanAnimal: '17%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 117,
    pathway: 'Gastric cancer',
    totalNumberPapers: '62',
    adSpecificPaperCount: '31',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.57812',
    literatureRank: '190',
    adSpecificPaperRank: '190',
    prcPapersAd: '48%',
    perDementia: '36%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '37%',
    perModel: '29%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '25%',
    perAnimal: '10%',
    perHuman: '78%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 118,
    pathway: 'Glioma',
    totalNumberPapers: '600',
    adSpecificPaperCount: '222',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '3.1875',
    literatureRank: '72',
    adSpecificPaperRank: '102',
    prcPapersAd: '37%',
    perDementia: '43%',
    perRelatedDementia: '16%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '19%',
    perModel: '38%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '38%',
    perAnimal: '10%',
    perHuman: '73%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 119,
    pathway: 'Glucagon signaling pathway',
    totalNumberPapers: '30',
    adSpecificPaperCount: '26',
    pathwayScore: 'good',
    adPathwayScore: '4.5',
    adWordScore: '4.96774',
    literatureRank: '209',
    adSpecificPaperRank: '195',
    prcPapersAd: '84%',
    perDementia: '13%',
    perRelatedDementia: '3%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '20%',
    perGenetic: '8%',
    perModel: '64%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '24%',
    perAnimal: '32%',
    perHuman: '24%',
    perBothHumanAnimal: '24%',
    perNeitherHumanAnimal: '20%'
  },
  {
    index: 120,
    pathway: 'Glutamatergic synapse',
    totalNumberPapers: '3771',
    adSpecificPaperCount: '2768',
    pathwayScore: 'high',
    adPathwayScore: '2.33333',
    adWordScore: '8.00981',
    literatureRank: '14',
    adSpecificPaperRank: '12',
    prcPapersAd: '73%',
    perDementia: '13%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '11%',
    perGenetic: '9%',
    perModel: '76%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '10%',
    perAnimal: '38%',
    perHuman: '40%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 121,
    pathway: 'Glutathione metabolism',
    totalNumberPapers: '1600',
    adSpecificPaperCount: '1109',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.02684',
    literatureRank: '29',
    adSpecificPaperRank: '27',
    prcPapersAd: '69%',
    perDementia: '16%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '19%',
    perGenetic: '10%',
    perModel: '77%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '8%',
    perAnimal: '53%',
    perHuman: '31%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 122,
    pathway: 'Glycerolipid metabolism',
    totalNumberPapers: '11',
    adSpecificPaperCount: '7',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '3.45455',
    literatureRank: '226',
    adSpecificPaperRank: '212',
    prcPapersAd: '64%',
    perDementia: '27%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '36%',
    perGenetic: '40%',
    perModel: '40%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '20%',
    perAnimal: '0%',
    perHuman: '60%',
    perBothHumanAnimal: '20%',
    perNeitherHumanAnimal: '20%'
  },
  {
    index: 123,
    pathway: 'Glycerophospholipid metabolism',
    totalNumberPapers: '49',
    adSpecificPaperCount: '40',
    pathwayScore: 'high',
    adPathwayScore: '2.66667',
    adWordScore: '7.30612',
    literatureRank: '198',
    adSpecificPaperRank: '182',
    prcPapersAd: '82%',
    perDementia: '14%',
    perRelatedDementia: '2%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '53%',
    perGenetic: '8%',
    perModel: '66%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '16%',
    perAnimal: '26%',
    perHuman: '39%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '24%'
  },
  {
    index: 124,
    pathway: 'Glycine serine and threonine metabolism',
    totalNumberPapers: '114',
    adSpecificPaperCount: '88',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '9.09565',
    literatureRank: '165',
    adSpecificPaperRank: '155',
    prcPapersAd: '77%',
    perDementia: '11%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '17%',
    perModel: '58%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '21%',
    perAnimal: '27%',
    perHuman: '50%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 125,
    pathway: 'Glycolysis Gluconeogenesis',
    totalNumberPapers: '295',
    adSpecificPaperCount: '231',
    pathwayScore: 'good',
    adPathwayScore: '3.125',
    adWordScore: '7.51864',
    literatureRank: '109',
    adSpecificPaperRank: '101',
    prcPapersAd: '79%',
    perDementia: '12%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '11%',
    perModel: '68%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '13%',
    perAnimal: '28%',
    perHuman: '50%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 126,
    pathway: 'Glycosaminoglycan biosynthesis',
    totalNumberPapers: '226',
    adSpecificPaperCount: '212',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '11.3656',
    literatureRank: '120',
    adSpecificPaperRank: '105',
    prcPapersAd: '93%',
    perDementia: '5%',
    perRelatedDementia: '1%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '10%',
    perGenetic: '10%',
    perModel: '59%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '25%',
    perAnimal: '27%',
    perHuman: '36%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '31%'
  },
  {
    index: 127,
    pathway: 'Glycosaminoglycan degradation',
    totalNumberPapers: '231',
    adSpecificPaperCount: '214',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '11.8182',
    literatureRank: '120',
    adSpecificPaperRank: '104',
    prcPapersAd: '93%',
    perDementia: '6%',
    perRelatedDementia: '1%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '10%',
    perModel: '59%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '25%',
    perAnimal: '27%',
    perHuman: '36%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '31%'
  },
  {
    index: 128,
    pathway: 'Glycosphingolipid biosynthesis',
    totalNumberPapers: '85',
    adSpecificPaperCount: '61',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.88235',
    literatureRank: '177',
    adSpecificPaperRank: '170',
    prcPapersAd: '72%',
    perDementia: '14%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '7%',
    perPapersUsingFullPathwayName: '29%',
    perGenetic: '14%',
    perModel: '62%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '11%',
    perAnimal: '18%',
    perHuman: '54%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 129,
    pathway: 'Glycosylphosphatidylinositol (GPI)-anchor biosynthesis',
    totalNumberPapers: '68',
    adSpecificPaperCount: '55',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '7.6087',
    literatureRank: '186',
    adSpecificPaperRank: '173',
    prcPapersAd: '80%',
    perDementia: '16%',
    perRelatedDementia: '3%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '9%',
    perGenetic: '5%',
    perModel: '80%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '7%',
    perAnimal: '32%',
    perHuman: '38%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '23%'
  },
  {
    index: 130,
    pathway: 'Glyoxylate and dicarboxylate metabolism',
    totalNumberPapers: '4',
    adSpecificPaperCount: '3',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '6',
    literatureRank: '227',
    adSpecificPaperRank: '216',
    prcPapersAd: '75%',
    perDementia: '25%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '25%',
    perGenetic: '22%',
    perModel: '56%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '22%',
    perAnimal: '11%',
    perHuman: '44%',
    perBothHumanAnimal: '22%',
    perNeitherHumanAnimal: '22%'
  },
  {
    index: 131,
    pathway: 'GnRH secretion',
    totalNumberPapers: '118',
    adSpecificPaperCount: '93',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '8.65254',
    literatureRank: '164',
    adSpecificPaperRank: '152',
    prcPapersAd: '79%',
    perDementia: '13%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '20%',
    perGenetic: '27%',
    perModel: '56%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '14%',
    perAnimal: '30%',
    perHuman: '54%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 132,
    pathway: 'GnRH signaling pathway',
    totalNumberPapers: '169',
    adSpecificPaperCount: '132',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '8.23392',
    literatureRank: '144',
    adSpecificPaperRank: '132',
    prcPapersAd: '77%',
    perDementia: '14%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '6%',
    perGenetic: '27%',
    perModel: '50%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '19%',
    perAnimal: '24%',
    perHuman: '60%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 133,
    pathway: 'Graft-versus-host disease',
    totalNumberPapers: '15',
    adSpecificPaperCount: '4',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '1.52941',
    literatureRank: '220',
    adSpecificPaperRank: '215',
    prcPapersAd: '24%',
    perDementia: '29%',
    perRelatedDementia: '35%',
    perUnrelatedDementia: '12%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '23%',
    perModel: '46%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '23%',
    perAnimal: '8%',
    perHuman: '54%',
    perBothHumanAnimal: '31%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 134,
    pathway: 'Hedgehog signaling pathway',
    totalNumberPapers: '35',
    adSpecificPaperCount: '26',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '4.81579',
    literatureRank: '204',
    adSpecificPaperRank: '195',
    prcPapersAd: '68%',
    perDementia: '8%',
    perRelatedDementia: '24%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '71%',
    perGenetic: '24%',
    perModel: '61%',
    perBothModelGenetic: '15%',
    perNeitherModelGenetic: '0%',
    perAnimal: '33%',
    perHuman: '52%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 135,
    pathway: 'Hematopoietic cell lineage',
    totalNumberPapers: '161',
    adSpecificPaperCount: '101',
    pathwayScore: 'good',
    adPathwayScore: '4.5',
    adWordScore: '6.2795',
    literatureRank: '147',
    adSpecificPaperRank: '146',
    prcPapersAd: '64%',
    perDementia: '19%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '13%',
    perGenetic: '12%',
    perModel: '69%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '7%',
    perAnimal: '35%',
    perHuman: '47%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 136,
    pathway: 'Hepatitis B',
    totalNumberPapers: '149',
    adSpecificPaperCount: '57',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.7947',
    literatureRank: '123',
    adSpecificPaperRank: '172',
    prcPapersAd: '38%',
    perDementia: '35%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '13%',
    perPapersUsingFullPathwayName: '24%',
    perGenetic: '33%',
    perModel: '29%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '30%',
    perAnimal: '8%',
    perHuman: '75%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 137,
    pathway: 'Hepatitis C',
    totalNumberPapers: '174',
    adSpecificPaperCount: '67',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '2.83889',
    literatureRank: '132',
    adSpecificPaperRank: '165',
    prcPapersAd: '37%',
    perDementia: '37%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '18%',
    perPapersUsingFullPathwayName: '52%',
    perGenetic: '35%',
    perModel: '25%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '32%',
    perAnimal: '6%',
    perHuman: '81%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 138,
    pathway: 'Hepatocellular carcinoma',
    totalNumberPapers: '76',
    adSpecificPaperCount: '34',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '1.89744',
    literatureRank: '180',
    adSpecificPaperRank: '187',
    prcPapersAd: '44%',
    perDementia: '42%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '18%',
    perModel: '73%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '0%',
    perAnimal: '2%',
    perHuman: '71%',
    perBothHumanAnimal: '15%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 139,
    pathway: 'Herpes simplex virus 1 infection',
    totalNumberPapers: '363',
    adSpecificPaperCount: '231',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '6.9697',
    literatureRank: '97',
    adSpecificPaperRank: '101',
    prcPapersAd: '64%',
    perDementia: '20%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '10%',
    perPapersUsingFullPathwayName: '38%',
    perGenetic: '44%',
    perModel: '25%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '24%',
    perAnimal: '8%',
    perHuman: '77%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 140,
    pathway: 'HIF-1 signaling pathway',
    totalNumberPapers: '137',
    adSpecificPaperCount: '79',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '7.62774',
    literatureRank: '155',
    adSpecificPaperRank: '160',
    prcPapersAd: '58%',
    perDementia: '13%',
    perRelatedDementia: '28%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '16%',
    perGenetic: '17%',
    perModel: '70%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '5%',
    perAnimal: '44%',
    perHuman: '37%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 141,
    pathway: 'Hippo signaling pathway',
    totalNumberPapers: '3',
    adSpecificPaperCount: '2',
    pathwayScore: 'high',
    adPathwayScore: '3.33333',
    adWordScore: '7',
    literatureRank: '234',
    adSpecificPaperRank: '217',
    prcPapersAd: '67%',
    perDementia: '33%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '67%',
    perGenetic: '0%',
    perModel: '100%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '50%',
    perHuman: '0%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '50%'
  },
  {
    index: 142,
    pathway: 'Histidine metabolism',
    totalNumberPapers: '156',
    adSpecificPaperCount: '120',
    pathwayScore: 'ok',
    adPathwayScore: '4',
    adWordScore: '8.7963',
    literatureRank: '146',
    adSpecificPaperRank: '138',
    prcPapersAd: '74%',
    perDementia: '16%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '15%',
    perModel: '53%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '26%',
    perAnimal: '26%',
    perHuman: '49%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '21%'
  },
  {
    index: 143,
    pathway: 'Homologous recombination',
    totalNumberPapers: '30',
    adSpecificPaperCount: '24',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '7.94286',
    literatureRank: '206',
    adSpecificPaperRank: '197',
    prcPapersAd: '69%',
    perDementia: '20%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '40%',
    perModel: '30%',
    perBothModelGenetic: '27%',
    perNeitherModelGenetic: '3%',
    perAnimal: '47%',
    perHuman: '37%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 144,
    pathway: 'Human cytomegalovirus infection',
    totalNumberPapers: '133',
    adSpecificPaperCount: '54',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '4.74436',
    literatureRank: '158',
    adSpecificPaperRank: '174',
    prcPapersAd: '41%',
    perDementia: '17%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '31%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '29%',
    perModel: '34%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '27%',
    perAnimal: '15%',
    perHuman: '80%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 145,
    pathway: 'Human immunodeficiency virus 1 infection',
    totalNumberPapers: '3126',
    adSpecificPaperCount: '450',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '2.39022',
    literatureRank: '19',
    adSpecificPaperRank: '66',
    prcPapersAd: '14%',
    perDementia: '9%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '67%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '21%',
    perModel: '45%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '29%',
    perAnimal: '5%',
    perHuman: '89%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 146,
    pathway: 'Human papillomavirus infection',
    totalNumberPapers: '3',
    adSpecificPaperCount: '3',
    pathwayScore: 'high',
    adPathwayScore: '2.33333',
    adWordScore: '10',
    literatureRank: '225',
    adSpecificPaperRank: '216',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '29%',
    perModel: '57%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '0%',
    perAnimal: '14%',
    perHuman: '57%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '29%'
  },
  {
    index: 147,
    pathway: 'Human T-cell leukemia virus 1 infection',
    totalNumberPapers: '80',
    adSpecificPaperCount: '18',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.7',
    literatureRank: '179',
    adSpecificPaperRank: '202',
    prcPapersAd: '23%',
    perDementia: '34%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '37%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '26%',
    perModel: '50%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '13%',
    perAnimal: '29%',
    perHuman: '62%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '1%'
  },
  {
    index: 148,
    pathway: 'Huntington disease',
    totalNumberPapers: '3432',
    adSpecificPaperCount: '417',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '4.50612',
    literatureRank: '18',
    adSpecificPaperRank: '74',
    prcPapersAd: '12%',
    perDementia: '1%',
    perRelatedDementia: '86%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '24%',
    perModel: '50%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '19%',
    perAnimal: '19%',
    perHuman: '60%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 149,
    pathway: 'Hypertrophic cardiomyopathy (HCM)',
    totalNumberPapers: '95',
    adSpecificPaperCount: '22',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.375',
    literatureRank: '158',
    adSpecificPaperRank: '199',
    prcPapersAd: '23%',
    perDementia: '45%',
    perRelatedDementia: '25%',
    perUnrelatedDementia: '7%',
    perPapersUsingFullPathwayName: '17%',
    perGenetic: '50%',
    perModel: '18%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '26%',
    perAnimal: '13%',
    perHuman: '75%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 150,
    pathway: 'IL-17 signaling pathway',
    totalNumberPapers: '57',
    adSpecificPaperCount: '34',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '9.38596',
    literatureRank: '195',
    adSpecificPaperRank: '187',
    prcPapersAd: '61%',
    perDementia: '25%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '12%',
    perGenetic: '6%',
    perModel: '68%',
    perBothModelGenetic: '12%',
    perNeitherModelGenetic: '14%',
    perAnimal: '44%',
    perHuman: '42%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 151,
    pathway: 'immune system',
    totalNumberPapers: '15801',
    adSpecificPaperCount: '10594',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.35822',
    literatureRank: '3',
    adSpecificPaperRank: '2',
    prcPapersAd: '67%',
    perDementia: '17%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '7%',
    perGenetic: '19%',
    perModel: '62%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '13%',
    perAnimal: '31%',
    perHuman: '51%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 152,
    pathway: 'Inflammatory bowel disease (IBD)',
    totalNumberPapers: '84',
    adSpecificPaperCount: '30',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '1.83529',
    literatureRank: '177',
    adSpecificPaperRank: '191',
    prcPapersAd: '35%',
    perDementia: '47%',
    perRelatedDementia: '18%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '94%',
    perGenetic: '38%',
    perModel: '30%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '22%',
    perAnimal: '8%',
    perHuman: '62%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '20%'
  },
  {
    index: 153,
    pathway: 'Inflammatory mediator regulation of TRP channels',
    totalNumberPapers: '7',
    adSpecificPaperCount: '5',
    pathwayScore: 'high',
    adPathwayScore: '2.42857',
    adWordScore: '8.42857',
    literatureRank: '229',
    adSpecificPaperRank: '214',
    prcPapersAd: '71%',
    perDementia: '0%',
    perRelatedDementia: '29%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '14%',
    perGenetic: '0%',
    perModel: '75%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '25%',
    perAnimal: '50%',
    perHuman: '50%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 154,
    pathway: 'Influenza A',
    totalNumberPapers: '161',
    adSpecificPaperCount: '61',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '3.14198',
    literatureRank: '146',
    adSpecificPaperRank: '170',
    prcPapersAd: '38%',
    perDementia: '55%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '32%',
    perModel: '18%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '43%',
    perAnimal: '7%',
    perHuman: '72%',
    perBothHumanAnimal: '2%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 155,
    pathway: 'Innate immune system',
    totalNumberPapers: '655',
    adSpecificPaperCount: '498',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.59299',
    literatureRank: '70',
    adSpecificPaperRank: '63',
    prcPapersAd: '76%',
    perDementia: '16%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '22%',
    perModel: '64%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '6%',
    perAnimal: '27%',
    perHuman: '49%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 156,
    pathway: 'Inositol phosphate metabolism',
    totalNumberPapers: '554',
    adSpecificPaperCount: '438',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '8.64505',
    literatureRank: '75',
    adSpecificPaperRank: '71',
    prcPapersAd: '79%',
    perDementia: '11%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '14%',
    perGenetic: '13%',
    perModel: '66%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '16%',
    perAnimal: '28%',
    perHuman: '54%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 157,
    pathway: 'Insulin resistance',
    totalNumberPapers: '1013',
    adSpecificPaperCount: '761',
    pathwayScore: 'good',
    adPathwayScore: '1.5',
    adWordScore: '9.75025',
    literatureRank: '49',
    adSpecificPaperRank: '50',
    prcPapersAd: '75%',
    perDementia: '13%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '29%',
    perModel: '52%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '10%',
    perAnimal: '32%',
    perHuman: '53%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 158,
    pathway: 'Insulin secretion',
    totalNumberPapers: '2209',
    adSpecificPaperCount: '1639',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '9.39022',
    literatureRank: '20',
    adSpecificPaperRank: '18',
    prcPapersAd: '74%',
    perDementia: '15%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '12%',
    perGenetic: '25%',
    perModel: '55%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '13%',
    perAnimal: '32%',
    perHuman: '50%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 159,
    pathway: 'Insulin signaling pathway',
    totalNumberPapers: '2931',
    adSpecificPaperCount: '2285',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '9.971',
    literatureRank: '20',
    adSpecificPaperRank: '16',
    prcPapersAd: '78%',
    perDementia: '12%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '30%',
    perGenetic: '25%',
    perModel: '55%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '13%',
    perAnimal: '32%',
    perHuman: '50%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 160,
    pathway: 'Intestinal immune network for IgA production',
    totalNumberPapers: '64',
    adSpecificPaperCount: '43',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '6.10606',
    literatureRank: '189',
    adSpecificPaperRank: '179',
    prcPapersAd: '65%',
    perDementia: '21%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '3%',
    perGenetic: '19%',
    perModel: '27%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '49%',
    perAnimal: '5%',
    perHuman: '87%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 161,
    pathway: 'JAK-STAT signaling pathway',
    totalNumberPapers: '243',
    adSpecificPaperCount: '163',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '7.90535',
    literatureRank: '122',
    adSpecificPaperRank: '116',
    prcPapersAd: '67%',
    perDementia: '20%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '16%',
    perModel: '70%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '6%',
    perAnimal: '30%',
    perHuman: '44%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 162,
    pathway: 'Kaposi sarcoma-associated herpesvirus infection',
    totalNumberPapers: '6',
    adSpecificPaperCount: '0',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '0.666667',
    literatureRank: '225',
    adSpecificPaperRank: '219',
    prcPapersAd: '0%',
    perDementia: '33%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '66%',
    perPapersUsingFullPathwayName: '33%',
    perGenetic: '30%',
    perModel: '30%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '40%',
    perAnimal: '10%',
    perHuman: '80%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 163,
    pathway: 'Legionellosis',
    totalNumberPapers: '2',
    adSpecificPaperCount: '2',
    pathwayScore: 'NA',
    adPathwayScore: '4',
    adWordScore: '1',
    literatureRank: '234',
    adSpecificPaperRank: '217',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '0%',
    perModel: '100%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 164,
    pathway: 'Leishmaniasis',
    totalNumberPapers: '20',
    adSpecificPaperCount: '15',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '2.19048',
    literatureRank: '218',
    adSpecificPaperRank: '205',
    prcPapersAd: '71%',
    perDementia: '24%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '27%',
    perModel: '40%',
    perBothModelGenetic: '27%',
    perNeitherModelGenetic: '7%',
    perAnimal: '7%',
    perHuman: '80%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 165,
    pathway: 'Leukocyte transendothelial migration',
    totalNumberPapers: '77',
    adSpecificPaperCount: '33',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '4.5974',
    literatureRank: '181',
    adSpecificPaperRank: '188',
    prcPapersAd: '44%',
    perDementia: '23%',
    perRelatedDementia: '21%',
    perUnrelatedDementia: '12%',
    perPapersUsingFullPathwayName: '3%',
    perGenetic: '19%',
    perModel: '72%',
    perBothModelGenetic: '2%',
    perNeitherModelGenetic: '7%',
    perAnimal: '19%',
    perHuman: '66%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '2%'
  },
  {
    index: 166,
    pathway: 'Linoleic acid metabolism',
    totalNumberPapers: '72',
    adSpecificPaperCount: '49',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '5.19178',
    literatureRank: '185',
    adSpecificPaperRank: '176',
    prcPapersAd: '67%',
    perDementia: '23%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '29%',
    perGenetic: '20%',
    perModel: '56%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '17%',
    perAnimal: '38%',
    perHuman: '42%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 167,
    pathway: 'Lipoic acid metabolism',
    totalNumberPapers: '151',
    adSpecificPaperCount: '121',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '8.19205',
    literatureRank: '150',
    adSpecificPaperRank: '137',
    prcPapersAd: '80%',
    perDementia: '13%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '24%',
    perGenetic: '9%',
    perModel: '76%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '13%',
    perAnimal: '42%',
    perHuman: '34%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 168,
    pathway: 'Longevity regulating pathway',
    totalNumberPapers: '830',
    adSpecificPaperCount: '489',
    pathwayScore: 'ok',
    adPathwayScore: '3.5',
    adWordScore: '7.33253',
    literatureRank: '58',
    adSpecificPaperRank: '64',
    prcPapersAd: '59%',
    perDementia: '28%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '17%',
    perGenetic: '40%',
    perModel: '41%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '12%',
    perAnimal: '26%',
    perHuman: '61%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 169,
    pathway: 'Long-term depression',
    totalNumberPapers: '12050',
    adSpecificPaperCount: '5128',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '4.60664',
    literatureRank: '5',
    adSpecificPaperRank: '5',
    prcPapersAd: '43%',
    perDementia: '41%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '32%',
    perModel: '20%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '45%',
    perAnimal: '7%',
    perHuman: '87%',
    perBothHumanAnimal: '2%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 170,
    pathway: 'Long-term potentiation',
    totalNumberPapers: '1454',
    adSpecificPaperCount: '1258',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '14.0028',
    literatureRank: '33',
    adSpecificPaperRank: '24',
    prcPapersAd: '87%',
    perDementia: '4%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '91%',
    perGenetic: '5%',
    perModel: '88%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '3%',
    perAnimal: '63%',
    perHuman: '18%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 171,
    pathway: 'Lysine degradation',
    totalNumberPapers: '262',
    adSpecificPaperCount: '207',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '8.5',
    literatureRank: '115',
    adSpecificPaperRank: '106',
    prcPapersAd: '77%',
    perDementia: '10%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '6%',
    perGenetic: '16%',
    perModel: '59%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '17%',
    perAnimal: '28%',
    perHuman: '43%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '22%'
  },
  {
    index: 172,
    pathway: 'Lysosome',
    totalNumberPapers: '1519',
    adSpecificPaperCount: '1022',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '9.70112',
    literatureRank: '32',
    adSpecificPaperRank: '32',
    prcPapersAd: '67%',
    perDementia: '13%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '17%',
    perModel: '68%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '5%',
    perAnimal: '30%',
    perHuman: '45%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 173,
    pathway: 'Malaria',
    totalNumberPapers: '111',
    adSpecificPaperCount: '61',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '1.66667',
    literatureRank: '167',
    adSpecificPaperRank: '170',
    prcPapersAd: '55%',
    perDementia: '39%',
    perRelatedDementia: '4%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '25%',
    perModel: '35%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '31%',
    perAnimal: '17%',
    perHuman: '55%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '23%'
  },
  {
    index: 174,
    pathway: 'Mannose type O-glycan biosynthesis',
    totalNumberPapers: '62',
    adSpecificPaperCount: '61',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '11.9516',
    literatureRank: '192',
    adSpecificPaperRank: '170',
    prcPapersAd: '98%',
    perDementia: '0%',
    perRelatedDementia: '2%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '20%',
    perModel: '57%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '13%',
    perAnimal: '13%',
    perHuman: '59%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '23%'
  },
  {
    index: 175,
    pathway: 'MAPK signaling pathway',
    totalNumberPapers: '1177',
    adSpecificPaperCount: '951',
    pathwayScore: 'high',
    adPathwayScore: '1.83333',
    adWordScore: '9.79086',
    literatureRank: '43',
    adSpecificPaperRank: '36',
    prcPapersAd: '81%',
    perDementia: '9%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '36%',
    perGenetic: '8%',
    perModel: '81%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '4%',
    perAnimal: '43%',
    perHuman: '32%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 176,
    pathway: 'Maturity onset diabetes of the young',
    totalNumberPapers: '1',
    adSpecificPaperCount: '1',
    pathwayScore: 'high',
    adPathwayScore: '5',
    adWordScore: '2',
    literatureRank: '236',
    adSpecificPaperRank: '218',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  },
  {
    index: 177,
    pathway: 'Measles',
    totalNumberPapers: '39',
    adSpecificPaperCount: '14',
    pathwayScore: 'high',
    adPathwayScore: '3.66667',
    adWordScore: '2',
    literatureRank: '201',
    adSpecificPaperRank: '206',
    prcPapersAd: '32%',
    perDementia: '52%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '10%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '23%',
    perModel: '14%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '54%',
    perAnimal: '3%',
    perHuman: '89%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 178,
    pathway: 'Melanogenesis',
    totalNumberPapers: '125',
    adSpecificPaperCount: '54',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '5.11905',
    literatureRank: '161',
    adSpecificPaperRank: '174',
    prcPapersAd: '43%',
    perDementia: '12%',
    perRelatedDementia: '45%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '32%',
    perGenetic: '7%',
    perModel: '77%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '13%',
    perAnimal: '11%',
    perHuman: '69%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 179,
    pathway: 'Melanoma',
    totalNumberPapers: '148',
    adSpecificPaperCount: '79',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '4.14189',
    literatureRank: '151',
    adSpecificPaperRank: '160',
    prcPapersAd: '54%',
    perDementia: '28%',
    perRelatedDementia: '16%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '40%',
    perModel: '38%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '15%',
    perAnimal: '12%',
    perHuman: '73%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 180,
    pathway: 'Metabolic pathways',
    totalNumberPapers: '14478',
    adSpecificPaperCount: '10106',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '8.60623',
    literatureRank: '4',
    adSpecificPaperRank: '3',
    prcPapersAd: '70%',
    perDementia: '15%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '3%',
    perGenetic: '25%',
    perModel: '49%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '21%',
    perAnimal: '21%',
    perHuman: '65%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 181,
    pathway: 'Metabolism of xenobiotics by cytochrome P450',
    totalNumberPapers: '299',
    adSpecificPaperCount: '184',
    pathwayScore: 'good',
    adPathwayScore: '4.33333',
    adWordScore: '4.31229',
    literatureRank: '108',
    adSpecificPaperRank: '111',
    prcPapersAd: '61%',
    perDementia: '25%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '40%',
    perModel: '47%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '7%',
    perAnimal: '21%',
    perHuman: '57%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 182,
    pathway: 'MicroRNAs in cancer',
    totalNumberPapers: '108',
    adSpecificPaperCount: '64',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '5.21296',
    literatureRank: '169',
    adSpecificPaperRank: '167',
    prcPapersAd: '59%',
    perDementia: '26%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '42%',
    perModel: '45%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '4%',
    perAnimal: '20%',
    perHuman: '62%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 183,
    pathway: 'Mineral absorption',
    totalNumberPapers: '11',
    adSpecificPaperCount: '6',
    pathwayScore: 'low',
    adPathwayScore: '2.66667',
    adWordScore: '3.33333',
    literatureRank: '222',
    adSpecificPaperRank: '213',
    prcPapersAd: '55%',
    perDementia: '36%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '9%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '38%',
    perModel: '31%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '31%',
    perAnimal: '23%',
    perHuman: '69%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 184,
    pathway: 'Mismatch repair',
    totalNumberPapers: '6',
    adSpecificPaperCount: '3',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '4.5',
    literatureRank: '230',
    adSpecificPaperRank: '216',
    prcPapersAd: '50%',
    perDementia: '17%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '17%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '33%',
    perModel: '33%',
    perBothModelGenetic: '33%',
    perNeitherModelGenetic: '0%',
    perAnimal: '67%',
    perHuman: '0%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '33%'
  },
  {
    index: 185,
    pathway: 'Mitophagy',
    totalNumberPapers: '85',
    adSpecificPaperCount: '41',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '6.63529',
    literatureRank: '177',
    adSpecificPaperRank: '181',
    prcPapersAd: '48%',
    perDementia: '14%',
    perRelatedDementia: '38%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '25%',
    perModel: '67%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '4%',
    perAnimal: '38%',
    perHuman: '40%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 186,
    pathway: 'Morphine addiction',
    totalNumberPapers: '176',
    adSpecificPaperCount: '80',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '3.88636',
    literatureRank: '141',
    adSpecificPaperRank: '159',
    prcPapersAd: '45%',
    perDementia: '34%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '10%',
    perGenetic: '12%',
    perModel: '63%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '21%',
    perAnimal: '30%',
    perHuman: '53%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 187,
    pathway: 'mRNA surveillance pathway',
    totalNumberPapers: '71',
    adSpecificPaperCount: '48',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '4.9726',
    literatureRank: '185',
    adSpecificPaperRank: '177',
    prcPapersAd: '66%',
    perDementia: '12%',
    perRelatedDementia: '22%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '55%',
    perModel: '30%',
    perBothModelGenetic: '15%',
    perNeitherModelGenetic: '0%',
    perAnimal: '18%',
    perHuman: '63%',
    perBothHumanAnimal: '15%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 188,
    pathway: 'mTOR signaling pathway',
    totalNumberPapers: '474',
    adSpecificPaperCount: '356',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '9.95781',
    literatureRank: '85',
    adSpecificPaperRank: '85',
    prcPapersAd: '75%',
    perDementia: '11%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '45%',
    perGenetic: '13%',
    perModel: '75%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '4%',
    perAnimal: '43%',
    perHuman: '34%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 189,
    pathway: 'Mucin type O-glycan biosynthesis',
    totalNumberPapers: '62',
    adSpecificPaperCount: '61',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '11.9516',
    literatureRank: '192',
    adSpecificPaperRank: '170',
    prcPapersAd: '98%',
    perDementia: '0%',
    perRelatedDementia: '2%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '20%',
    perModel: '57%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '13%',
    perAnimal: '13%',
    perHuman: '59%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '23%'
  },
  {
    index: 190,
    pathway: 'Natural killer cell mediated cytotoxicity',
    totalNumberPapers: '75',
    adSpecificPaperCount: '44',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '3.9375',
    literatureRank: '179',
    adSpecificPaperRank: '178',
    prcPapersAd: '55%',
    perDementia: '30%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '23%',
    perGenetic: '22%',
    perModel: '43%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '28%',
    perAnimal: '10%',
    perHuman: '85%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 191,
    pathway: 'Necroptosis',
    totalNumberPapers: '15',
    adSpecificPaperCount: '9',
    pathwayScore: 'high',
    adPathwayScore: '3.35714',
    adWordScore: '4.70588',
    literatureRank: '220',
    adSpecificPaperRank: '211',
    prcPapersAd: '53%',
    perDementia: '12%',
    perRelatedDementia: '29%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '7%',
    perModel: '93%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '50%',
    perHuman: '36%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 192,
    pathway: 'Neomycin kanamycin and gentamicin biosynthesis',
    totalNumberPapers: '15',
    adSpecificPaperCount: '13',
    pathwayScore: 'high',
    adPathwayScore: '4.33333',
    adWordScore: '3.47619',
    literatureRank: '218',
    adSpecificPaperRank: '207',
    prcPapersAd: '62%',
    perDementia: '14%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '15%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '42%',
    perModel: '47%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '5%',
    perAnimal: '32%',
    perHuman: '63%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 193,
    pathway: 'Neuroactive ligand-receptor interaction',
    totalNumberPapers: '13',
    adSpecificPaperCount: '11',
    pathwayScore: 'high',
    adPathwayScore: '1.66667',
    adWordScore: '5.06667',
    literatureRank: '222',
    adSpecificPaperRank: '209',
    prcPapersAd: '73%',
    perDementia: '7%',
    perRelatedDementia: '20%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '43%',
    perModel: '36%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '14%',
    perAnimal: '21%',
    perHuman: '64%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 194,
    pathway: 'Neurotrophin signaling pathway',
    totalNumberPapers: '799',
    adSpecificPaperCount: '632',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.77972',
    literatureRank: '62',
    adSpecificPaperRank: '55',
    prcPapersAd: '79%',
    perDementia: '11%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '30%',
    perGenetic: '9%',
    perModel: '79%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '4%',
    perAnimal: '39%',
    perHuman: '41%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 195,
    pathway: 'NF-kappa B signaling pathway',
    totalNumberPapers: '1275',
    adSpecificPaperCount: '938',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '8.86667',
    literatureRank: '39',
    adSpecificPaperRank: '37',
    prcPapersAd: '74%',
    perDementia: '14%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '28%',
    perGenetic: '10%',
    perModel: '79%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '4%',
    perAnimal: '46%',
    perHuman: '31%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 196,
    pathway: 'N-Glycan biosynthesis',
    totalNumberPapers: '128',
    adSpecificPaperCount: '106',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '9.82812',
    literatureRank: '160',
    adSpecificPaperRank: '144',
    prcPapersAd: '83%',
    perDementia: '8%',
    perRelatedDementia: '5%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '92%',
    perGenetic: '30%',
    perModel: '44%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '17%',
    perAnimal: '18%',
    perHuman: '59%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 197,
    pathway: 'Nicotinate and nicotinamide metabolism',
    totalNumberPapers: '253',
    adSpecificPaperCount: '143',
    pathwayScore: 'good',
    adPathwayScore: '4.5',
    adWordScore: '5.82353',
    literatureRank: '118',
    adSpecificPaperRank: '125',
    prcPapersAd: '57%',
    perDementia: '24%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '11%',
    perModel: '69%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '14%',
    perAnimal: '40%',
    perHuman: '38%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 198,
    pathway: 'Nicotine addiction',
    totalNumberPapers: '829',
    adSpecificPaperCount: '628',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '7.44511',
    literatureRank: '59',
    adSpecificPaperRank: '56',
    prcPapersAd: '76%',
    perDementia: '14%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '14%',
    perGenetic: '13%',
    perModel: '68%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '14%',
    perAnimal: '35%',
    perHuman: '46%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 199,
    pathway: 'Nitrogen metabolism',
    totalNumberPapers: '345',
    adSpecificPaperCount: '190',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '6.75942',
    literatureRank: '100',
    adSpecificPaperRank: '109',
    prcPapersAd: '55%',
    perDementia: '23%',
    perRelatedDementia: '21%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '10%',
    perModel: '79%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '9%',
    perAnimal: '64%',
    perHuman: '20%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 200,
    pathway: 'NOD-like receptor signaling pathway',
    totalNumberPapers: '34',
    adSpecificPaperCount: '24',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '4.82857',
    literatureRank: '206',
    adSpecificPaperRank: '197',
    prcPapersAd: '69%',
    perDementia: '23%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '18%',
    perGenetic: '11%',
    perModel: '79%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '7%',
    perAnimal: '32%',
    perHuman: '46%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 201,
    pathway: 'Non-alcoholic fatty liver disease (NAFLD)',
    totalNumberPapers: '54',
    adSpecificPaperCount: '22',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '3.46296',
    literatureRank: '196',
    adSpecificPaperRank: '199',
    prcPapersAd: '41%',
    perDementia: '31%',
    perRelatedDementia: '26%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '54%',
    perGenetic: '50%',
    perModel: '39%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '8%',
    perAnimal: '21%',
    perHuman: '53%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 202,
    pathway: 'Non-homologous end-joining',
    totalNumberPapers: '9',
    adSpecificPaperCount: '7',
    pathwayScore: 'high',
    adPathwayScore: '2.14286',
    adWordScore: '7.45455',
    literatureRank: '221',
    adSpecificPaperRank: '212',
    prcPapersAd: '78%',
    perDementia: '0%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '11%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '55%',
    perModel: '18%',
    perBothModelGenetic: '27%',
    perNeitherModelGenetic: '0%',
    perAnimal: '18%',
    perHuman: '45%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '27%'
  },
  {
    index: 203,
    pathway: 'Non-small cell lung cancer',
    totalNumberPapers: '208',
    adSpecificPaperCount: '81',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '1.72381',
    literatureRank: '131',
    adSpecificPaperRank: '158',
    prcPapersAd: '39%',
    perDementia: '46%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '7%',
    perGenetic: '39%',
    perModel: '26%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '29%',
    perAnimal: '7%',
    perHuman: '71%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 204,
    pathway: 'Notch signaling pathway',
    totalNumberPapers: '1041',
    adSpecificPaperCount: '711',
    pathwayScore: 'high',
    adPathwayScore: '3.33333',
    adWordScore: '7.02111',
    literatureRank: '48',
    adSpecificPaperRank: '52',
    prcPapersAd: '68%',
    perDementia: '14%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '39%',
    perGenetic: '46%',
    perModel: '38%',
    perBothModelGenetic: '12%',
    perNeitherModelGenetic: '4%',
    perAnimal: '29%',
    perHuman: '49%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 205,
    pathway: 'Nucleotide excision repair',
    totalNumberPapers: '21',
    adSpecificPaperCount: '13',
    pathwayScore: 'good',
    adPathwayScore: '1.8',
    adWordScore: '6.59091',
    literatureRank: '217',
    adSpecificPaperRank: '207',
    prcPapersAd: '59%',
    perDementia: '23%',
    perRelatedDementia: '18%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '86%',
    perModel: '0%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '86%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 206,
    pathway: 'Olfactory transduction',
    totalNumberPapers: '1290',
    adSpecificPaperCount: '859',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.4644',
    literatureRank: '37',
    adSpecificPaperRank: '41',
    prcPapersAd: '67%',
    perDementia: '14%',
    perRelatedDementia: '18%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '17%',
    perModel: '54%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '25%',
    perAnimal: '33%',
    perHuman: '57%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 207,
    pathway: 'One carbon pool by folate',
    totalNumberPapers: '734',
    adSpecificPaperCount: '407',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '7.15918',
    literatureRank: '63',
    adSpecificPaperRank: '77',
    prcPapersAd: '55%',
    perDementia: '24%',
    perRelatedDementia: '18%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '55%',
    perModel: '18%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '22%',
    perAnimal: '12%',
    perHuman: '81%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 208,
    pathway: 'Oocyte meiosis',
    totalNumberPapers: '32',
    adSpecificPaperCount: '25',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '5.55556',
    literatureRank: '205',
    adSpecificPaperRank: '196',
    prcPapersAd: '69%',
    perDementia: '19%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '13%',
    perGenetic: '29%',
    perModel: '52%',
    perBothModelGenetic: '19%',
    perNeitherModelGenetic: '0%',
    perAnimal: '42%',
    perHuman: '42%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 209,
    pathway: 'Osteoclast differentiation',
    totalNumberPapers: '66',
    adSpecificPaperCount: '29',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '3.22388',
    literatureRank: '188',
    adSpecificPaperRank: '192',
    prcPapersAd: '43%',
    perDementia: '40%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '33%',
    perGenetic: '47%',
    perModel: '45%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '0%',
    perAnimal: '18%',
    perHuman: '63%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 210,
    pathway: 'Other glycan degradation',
    totalNumberPapers: '108',
    adSpecificPaperCount: '89',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '8.83486',
    literatureRank: '168',
    adSpecificPaperRank: '154',
    prcPapersAd: '82%',
    perDementia: '9%',
    perRelatedDementia: '4%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '7%',
    perGenetic: '26%',
    perModel: '47%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '20%',
    perAnimal: '19%',
    perHuman: '55%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '17%'
  },
  {
    index: 211,
    pathway: 'Other types of O-glycan biosynthesis',
    totalNumberPapers: '61',
    adSpecificPaperCount: '61',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '11.9516',
    literatureRank: '192',
    adSpecificPaperRank: '170',
    prcPapersAd: '98%',
    perDementia: '0%',
    perRelatedDementia: '2%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '16%',
    perGenetic: '20%',
    perModel: '57%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '13%',
    perAnimal: '13%',
    perHuman: '59%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '23%'
  },
  {
    index: 212,
    pathway: 'Ovarian steroidogenesis',
    totalNumberPapers: '138',
    adSpecificPaperCount: '96',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '7.44928',
    literatureRank: '154',
    adSpecificPaperRank: '149',
    prcPapersAd: '70%',
    perDementia: '21%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '51%',
    perGenetic: '20%',
    perModel: '51%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '15%',
    perAnimal: '24%',
    perHuman: '54%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 213,
    pathway: 'Oxidative phosphorylation',
    totalNumberPapers: '270',
    adSpecificPaperCount: '173',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '7.46154',
    literatureRank: '114',
    adSpecificPaperRank: '114',
    prcPapersAd: '63%',
    perDementia: '16%',
    perRelatedDementia: '19%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '32%',
    perModel: '49%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '11%',
    perAnimal: '33%',
    perHuman: '49%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 214,
    pathway: 'Oxytocin signaling pathway',
    totalNumberPapers: '74',
    adSpecificPaperCount: '58',
    pathwayScore: 'high',
    adPathwayScore: '4.33333',
    adWordScore: '3.85135',
    literatureRank: '184',
    adSpecificPaperRank: '171',
    prcPapersAd: '78%',
    perDementia: '7%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '9%',
    perGenetic: '32%',
    perModel: '48%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '13%',
    perAnimal: '18%',
    perHuman: '70%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 215,
    pathway: 'p53 signaling pathway',
    totalNumberPapers: '488',
    adSpecificPaperCount: '367',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '8.21107',
    literatureRank: '82',
    adSpecificPaperRank: '84',
    prcPapersAd: '75%',
    perDementia: '12%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '22%',
    perGenetic: '21%',
    perModel: '60%',
    perBothModelGenetic: '15%',
    perNeitherModelGenetic: '4%',
    perAnimal: '31%',
    perHuman: '47%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 216,
    pathway: 'Pancreatic cancer',
    totalNumberPapers: '49',
    adSpecificPaperCount: '26',
    pathwayScore: 'high',
    adPathwayScore: '4.33333',
    adWordScore: '2.83673',
    literatureRank: '198',
    adSpecificPaperRank: '195',
    prcPapersAd: '53%',
    perDementia: '33%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '56%',
    perModel: '33%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '6%',
    perAnimal: '11%',
    perHuman: '75%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 217,
    pathway: 'Pancreatic secretion',
    totalNumberPapers: '586',
    adSpecificPaperCount: '412',
    pathwayScore: 'good',
    adPathwayScore: '3.33333',
    adWordScore: '6.7568',
    literatureRank: '73',
    adSpecificPaperRank: '75',
    prcPapersAd: '70%',
    perDementia: '17%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '21%',
    perGenetic: '22%',
    perModel: '54%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '15%',
    perAnimal: '26%',
    perHuman: '54%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 218,
    pathway: 'Pantothenate and CoA biosynthesis',
    totalNumberPapers: '473',
    adSpecificPaperCount: '335',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '8.02114',
    literatureRank: '86',
    adSpecificPaperRank: '90',
    prcPapersAd: '71%',
    perDementia: '17%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '29%',
    perModel: '53%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '12%',
    perAnimal: '27%',
    perHuman: '55%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 219,
    pathway: 'Parathyroid hormone synthesis secretion and action',
    totalNumberPapers: '67',
    adSpecificPaperCount: '17',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '2.61765',
    literatureRank: '187',
    adSpecificPaperRank: '203',
    prcPapersAd: '25%',
    perDementia: '51%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '10%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '33%',
    perModel: '25%',
    perBothModelGenetic: '2%',
    perNeitherModelGenetic: '41%',
    perAnimal: '3%',
    perHuman: '86%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 220,
    pathway: 'Parkinson disease',
    totalNumberPapers: '18316',
    adSpecificPaperCount: '2372',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '4.63688',
    literatureRank: '2',
    adSpecificPaperRank: '15',
    prcPapersAd: '13%',
    perDementia: '2%',
    perRelatedDementia: '85%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '26%',
    perModel: '40%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '28%',
    perAnimal: '14%',
    perHuman: '69%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 221,
    pathway: 'Pathogenic Escherichia coli infection',
    totalNumberPapers: '329',
    adSpecificPaperCount: '276',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.59337',
    literatureRank: '102',
    adSpecificPaperRank: '97',
    prcPapersAd: '83%',
    perDementia: '11%',
    perRelatedDementia: '5%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '31%',
    perModel: '46%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '13%',
    perAnimal: '19%',
    perHuman: '53%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 222,
    pathway: 'Pathways in cancer',
    totalNumberPapers: '1286',
    adSpecificPaperCount: '778',
    pathwayScore: 'ok',
    adPathwayScore: '4.25',
    adWordScore: '5.03566',
    literatureRank: '38',
    adSpecificPaperRank: '47',
    prcPapersAd: '60%',
    perDementia: '25%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '27%',
    perModel: '53%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '8%',
    perAnimal: '25%',
    perHuman: '48%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '17%'
  },
  {
    index: 223,
    pathway: 'PD-L1 expression and PD-1 checkpoint pathway in cancer',
    totalNumberPapers: '5',
    adSpecificPaperCount: '1',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.2',
    literatureRank: '231',
    adSpecificPaperRank: '218',
    prcPapersAd: '20%',
    perDementia: '0%',
    perRelatedDementia: '80%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '60%',
    perGenetic: '0%',
    perModel: '33%',
    perBothModelGenetic: '33%',
    perNeitherModelGenetic: '33%',
    perAnimal: '33%',
    perHuman: '67%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 224,
    pathway: 'Pentose and glucuronate interconversions',
    totalNumberPapers: '51',
    adSpecificPaperCount: '50',
    pathwayScore: 'good',
    adPathwayScore: '4.33333',
    adWordScore: '6.27586',
    literatureRank: '194',
    adSpecificPaperRank: '175',
    prcPapersAd: '86%',
    perDementia: '7%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '10%',
    perModel: '61%',
    perBothModelGenetic: '16%',
    perNeitherModelGenetic: '14%',
    perAnimal: '27%',
    perHuman: '49%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 225,
    pathway: 'Pentose phosphate pathway',
    totalNumberPapers: '33',
    adSpecificPaperCount: '29',
    pathwayScore: 'high',
    adPathwayScore: '2.125',
    adWordScore: '5.94118',
    literatureRank: '207',
    adSpecificPaperRank: '192',
    prcPapersAd: '85%',
    perDementia: '6%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '97%',
    perGenetic: '11%',
    perModel: '61%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '18%',
    perAnimal: '29%',
    perHuman: '54%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 226,
    pathway: 'Peroxisome',
    totalNumberPapers: '444',
    adSpecificPaperCount: '339',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '10.1824',
    literatureRank: '88',
    adSpecificPaperRank: '89',
    prcPapersAd: '76%',
    perDementia: '9%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '14%',
    perModel: '74%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '5%',
    perAnimal: '45%',
    perHuman: '36%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 227,
    pathway: 'Pertussis',
    totalNumberPapers: '79',
    adSpecificPaperCount: '69',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '9.775',
    literatureRank: '179',
    adSpecificPaperRank: '163',
    prcPapersAd: '86%',
    perDementia: '6%',
    perRelatedDementia: '4%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '14%',
    perModel: '80%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '4%',
    perAnimal: '31%',
    perHuman: '49%',
    perBothHumanAnimal: '15%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 228,
    pathway: 'Phagosome',
    totalNumberPapers: '993',
    adSpecificPaperCount: '756',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '10.9456',
    literatureRank: '51',
    adSpecificPaperRank: '51',
    prcPapersAd: '76%',
    perDementia: '10%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '24%',
    perGenetic: '9%',
    perModel: '82%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '3%',
    perAnimal: '39%',
    perHuman: '37%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 229,
    pathway: 'Phenylalanine metabolism',
    totalNumberPapers: '118',
    adSpecificPaperCount: '95',
    pathwayScore: 'ok',
    adPathwayScore: '4',
    adWordScore: '6.93333',
    literatureRank: '163',
    adSpecificPaperRank: '150',
    prcPapersAd: '79%',
    perDementia: '13%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '31%',
    perGenetic: '21%',
    perModel: '34%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '35%',
    perAnimal: '17%',
    perHuman: '56%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '20%'
  },
  {
    index: 230,
    pathway: 'Phenylalanine tyrosine and tryptophan biosynthesis',
    totalNumberPapers: '1567',
    adSpecificPaperCount: '1078',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '7.49649',
    literatureRank: '31',
    adSpecificPaperRank: '28',
    prcPapersAd: '69%',
    perDementia: '14%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '14%',
    perModel: '65%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '14%',
    perAnimal: '33%',
    perHuman: '45%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 231,
    pathway: 'Phosphatidylinositol signaling system',
    totalNumberPapers: '394',
    adSpecificPaperCount: '330',
    pathwayScore: 'high',
    adPathwayScore: '3.33333',
    adWordScore: '9.35533',
    literatureRank: '95',
    adSpecificPaperRank: '91',
    prcPapersAd: '84%',
    perDementia: '8%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '48%',
    perGenetic: '13%',
    perModel: '71%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '10%',
    perAnimal: '35%',
    perHuman: '41%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 232,
    pathway: 'Phospholipase D signaling pathway',
    totalNumberPapers: '525',
    adSpecificPaperCount: '410',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '7.68381',
    literatureRank: '77',
    adSpecificPaperRank: '76',
    prcPapersAd: '78%',
    perDementia: '12%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '13%',
    perModel: '68%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '13%',
    perAnimal: '28%',
    perHuman: '45%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 233,
    pathway: 'Phosphonate and phosphinate metabolism',
    totalNumberPapers: '13',
    adSpecificPaperCount: '12',
    pathwayScore: 'good',
    adPathwayScore: '4.5',
    adWordScore: '7',
    literatureRank: '220',
    adSpecificPaperRank: '208',
    prcPapersAd: '92%',
    perDementia: '8%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '13%',
    perModel: '47%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '40%',
    perAnimal: '33%',
    perHuman: '27%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '33%'
  },
  {
    index: 234,
    pathway: 'Phototransduction',
    totalNumberPapers: '2',
    adSpecificPaperCount: '2',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '4',
    literatureRank: '235',
    adSpecificPaperRank: '217',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  },
  {
    index: 235,
    pathway: 'PI3K-Akt signaling pathway',
    totalNumberPapers: '1165',
    adSpecificPaperCount: '954',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '10.2352',
    literatureRank: '44',
    adSpecificPaperRank: '35',
    prcPapersAd: '82%',
    perDementia: '8%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '22%',
    perGenetic: '7%',
    perModel: '82%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '5%',
    perAnimal: '47%',
    perHuman: '31%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 236,
    pathway: 'Platelet activation',
    totalNumberPapers: '198',
    adSpecificPaperCount: '133',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '10.697',
    literatureRank: '136',
    adSpecificPaperRank: '131',
    prcPapersAd: '67%',
    perDementia: '11%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '18%',
    perModel: '59%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '18%',
    perAnimal: '18%',
    perHuman: '65%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 237,
    pathway: 'Platinum drug resistance',
    totalNumberPapers: '1',
    adSpecificPaperCount: '1',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '1.33333',
    literatureRank: '233',
    adSpecificPaperRank: '218',
    prcPapersAd: '0%',
    perDementia: '100%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '100%',
    perModel: '0%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 238,
    pathway: 'Porphyrin and chlorophyll metabolism',
    totalNumberPapers: '41',
    adSpecificPaperCount: '28',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '6.02326',
    literatureRank: '202',
    adSpecificPaperRank: '193',
    prcPapersAd: '65%',
    perDementia: '14%',
    perRelatedDementia: '16%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '16%',
    perModel: '51%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '32%',
    perAnimal: '22%',
    perHuman: '54%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '22%'
  },
  {
    index: 239,
    pathway: 'PPAR signaling pathway',
    totalNumberPapers: '551',
    adSpecificPaperCount: '428',
    pathwayScore: 'high',
    adPathwayScore: '2.66667',
    adWordScore: '10.0363',
    literatureRank: '76',
    adSpecificPaperRank: '72',
    prcPapersAd: '78%',
    perDementia: '9%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '15%',
    perModel: '73%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '6%',
    perAnimal: '44%',
    perHuman: '37%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 240,
    pathway: 'Primary bile acid biosynthesis',
    totalNumberPapers: '76',
    adSpecificPaperCount: '36',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '5.03896',
    literatureRank: '181',
    adSpecificPaperRank: '185',
    prcPapersAd: '47%',
    perDementia: '32%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '8%',
    perPapersUsingFullPathwayName: '47%',
    perGenetic: '35%',
    perModel: '45%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '15%',
    perAnimal: '20%',
    perHuman: '62%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 241,
    pathway: 'Primary immunodeficiency',
    totalNumberPapers: '24',
    adSpecificPaperCount: '18',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '4.10714',
    literatureRank: '212',
    adSpecificPaperRank: '202',
    prcPapersAd: '67%',
    perDementia: '30%',
    perRelatedDementia: '4%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '13%',
    perGenetic: '38%',
    perModel: '29%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '19%',
    perAnimal: '19%',
    perHuman: '67%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 242,
    pathway: 'Prion diseases',
    totalNumberPapers: '2623',
    adSpecificPaperCount: '1494',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '7.47104',
    literatureRank: '21',
    adSpecificPaperRank: '19',
    prcPapersAd: '57%',
    perDementia: '14%',
    perRelatedDementia: '16%',
    perUnrelatedDementia: '12%',
    perPapersUsingFullPathwayName: '47%',
    perGenetic: '30%',
    perModel: '49%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '14%',
    perAnimal: '19%',
    perHuman: '57%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 243,
    pathway: 'Progesterone-mediated oocyte maturation',
    totalNumberPapers: '3',
    adSpecificPaperCount: '3',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '9.66667',
    literatureRank: '234',
    adSpecificPaperRank: '216',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '0%',
    perModel: '50%',
    perBothModelGenetic: '50%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '50%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '50%'
  },
  {
    index: 244,
    pathway: 'Prolactin signaling pathway',
    totalNumberPapers: '96',
    adSpecificPaperCount: '68',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '4.54167',
    literatureRank: '174',
    adSpecificPaperRank: '164',
    prcPapersAd: '71%',
    perDementia: '17%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '6%',
    perGenetic: '14%',
    perModel: '35%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '44%',
    perAnimal: '11%',
    perHuman: '74%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 245,
    pathway: 'Propanoate metabolism',
    totalNumberPapers: '23',
    adSpecificPaperCount: '20',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '5.58621',
    literatureRank: '211',
    adSpecificPaperRank: '201',
    prcPapersAd: '69%',
    perDementia: '14%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '26%',
    perGenetic: '11%',
    perModel: '74%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '15%',
    perAnimal: '48%',
    perHuman: '33%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 246,
    pathway: 'Prostate cancer',
    totalNumberPapers: '267',
    adSpecificPaperCount: '135',
    pathwayScore: 'high',
    adPathwayScore: '5',
    adWordScore: '3.13858',
    literatureRank: '116',
    adSpecificPaperRank: '129',
    prcPapersAd: '51%',
    perDementia: '37%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '46%',
    perModel: '28%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '20%',
    perAnimal: '7%',
    perHuman: '74%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 247,
    pathway: 'Proteasome',
    totalNumberPapers: '4644',
    adSpecificPaperCount: '3834',
    pathwayScore: 'good',
    adPathwayScore: '3.16667',
    adWordScore: '10.4216',
    literatureRank: '11',
    adSpecificPaperRank: '7',
    prcPapersAd: '83%',
    perDementia: '8%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '19%',
    perGenetic: '22%',
    perModel: '57%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '12%',
    perAnimal: '25%',
    perHuman: '49%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 248,
    pathway: 'Protein digestion and absorption',
    totalNumberPapers: '33',
    adSpecificPaperCount: '20',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '4.52381',
    literatureRank: '203',
    adSpecificPaperRank: '201',
    prcPapersAd: '48%',
    perDementia: '31%',
    perRelatedDementia: '19%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '34%',
    perModel: '29%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '23%',
    perAnimal: '14%',
    perHuman: '71%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 249,
    pathway: 'Protein export',
    totalNumberPapers: '247',
    adSpecificPaperCount: '206',
    pathwayScore: 'high',
    adPathwayScore: '3.66667',
    adWordScore: '10.7733',
    literatureRank: '121',
    adSpecificPaperRank: '107',
    prcPapersAd: '83%',
    perDementia: '8%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '5%',
    perGenetic: '21%',
    perModel: '65%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '5%',
    perAnimal: '29%',
    perHuman: '44%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '19%'
  },
  {
    index: 250,
    pathway: 'Protein processing in endoplasmic reticulum',
    totalNumberPapers: '1352',
    adSpecificPaperCount: '1050',
    pathwayScore: 'good',
    adPathwayScore: '2.5',
    adWordScore: '8.54472',
    literatureRank: '36',
    adSpecificPaperRank: '30',
    prcPapersAd: '78%',
    perDementia: '11%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '21%',
    perModel: '64%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '4%',
    perAnimal: '33%',
    perHuman: '44%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 251,
    pathway: 'Proteoglycans in cancer',
    totalNumberPapers: '16',
    adSpecificPaperCount: '14',
    pathwayScore: 'ok',
    adPathwayScore: '4.25',
    adWordScore: '5.6875',
    literatureRank: '221',
    adSpecificPaperRank: '206',
    prcPapersAd: '88%',
    perDementia: '13%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '25%',
    perModel: '58%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '8%',
    perAnimal: '17%',
    perHuman: '33%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '50%'
  },
  {
    index: 252,
    pathway: 'Proximal tubule bicarbonate reclamation',
    totalNumberPapers: '0',
    adSpecificPaperCount: '0',
    pathwayScore: 'NA',
    adPathwayScore: 'NA',
    adWordScore: '0',
    literatureRank: '237',
    adSpecificPaperRank: '219',
    prcPapersAd: '0%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  },
  {
    index: 253,
    pathway: 'Purine metabolism',
    totalNumberPapers: '207',
    adSpecificPaperCount: '140',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '6.74641',
    literatureRank: '132',
    adSpecificPaperRank: '127',
    prcPapersAd: '67%',
    perDementia: '20%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '35%',
    perGenetic: '24%',
    perModel: '56%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '13%',
    perAnimal: '29%',
    perHuman: '49%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 254,
    pathway: 'Pyrimidine metabolism',
    totalNumberPapers: '45',
    adSpecificPaperCount: '36',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '6.83673',
    literatureRank: '198',
    adSpecificPaperRank: '185',
    prcPapersAd: '73%',
    perDementia: '18%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '24%',
    perGenetic: '34%',
    perModel: '41%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '14%',
    perAnimal: '20%',
    perHuman: '52%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '23%'
  },
  {
    index: 255,
    pathway: 'Pyruvate metabolism',
    totalNumberPapers: '226',
    adSpecificPaperCount: '173',
    pathwayScore: 'high',
    adPathwayScore: '4.33333',
    adWordScore: '7.80349',
    literatureRank: '124',
    adSpecificPaperRank: '114',
    prcPapersAd: '76%',
    perDementia: '18%',
    perRelatedDementia: '5%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '59%',
    perGenetic: '12%',
    perModel: '68%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '15%',
    perAnimal: '33%',
    perHuman: '47%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 256,
    pathway: 'Rap1 signaling pathway',
    totalNumberPapers: '14',
    adSpecificPaperCount: '12',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '5.73333',
    literatureRank: '222',
    adSpecificPaperRank: '208',
    prcPapersAd: '80%',
    perDementia: '7%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '50%',
    perGenetic: '21%',
    perModel: '50%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '14%',
    perAnimal: '7%',
    perHuman: '57%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '21%'
  },
  {
    index: 257,
    pathway: 'Ras signaling pathway',
    totalNumberPapers: '151',
    adSpecificPaperCount: '119',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '7.49669',
    literatureRank: '150',
    adSpecificPaperRank: '139',
    prcPapersAd: '79%',
    perDementia: '13%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '47%',
    perGenetic: '24%',
    perModel: '53%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '9%',
    perAnimal: '27%',
    perHuman: '49%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '16%'
  },
  {
    index: 258,
    pathway: 'Regulation of actin cytoskeleton',
    totalNumberPapers: '822',
    adSpecificPaperCount: '681',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '9.34751',
    literatureRank: '60',
    adSpecificPaperRank: '53',
    prcPapersAd: '83%',
    perDementia: '9%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '63%',
    perGenetic: '15%',
    perModel: '70%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '5%',
    perAnimal: '34%',
    perHuman: '44%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 259,
    pathway: 'Regulation of lipolysis in adipocytes',
    totalNumberPapers: '11',
    adSpecificPaperCount: '10',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.21429',
    literatureRank: '223',
    adSpecificPaperRank: '210',
    prcPapersAd: '71%',
    perDementia: '7%',
    perRelatedDementia: '21%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '36%',
    perGenetic: '46%',
    perModel: '46%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '0%',
    perAnimal: '23%',
    perHuman: '46%',
    perBothHumanAnimal: '15%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 260,
    pathway: 'Relaxin signaling pathway',
    totalNumberPapers: '2',
    adSpecificPaperCount: '2',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '8.5',
    literatureRank: '235',
    adSpecificPaperRank: '217',
    prcPapersAd: '100%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '0%',
    perModel: '0%',
    perBothModelGenetic: '100%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 261,
    pathway: 'Renal cell carcinoma',
    totalNumberPapers: '24',
    adSpecificPaperCount: '13',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '5.96',
    literatureRank: '214',
    adSpecificPaperRank: '207',
    prcPapersAd: '52%',
    perDementia: '40%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '30%',
    perModel: '40%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '30%',
    perAnimal: '15%',
    perHuman: '70%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 262,
    pathway: 'Renin secretion',
    totalNumberPapers: '206',
    adSpecificPaperCount: '107',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '6.5534',
    literatureRank: '133',
    adSpecificPaperRank: '143',
    prcPapersAd: '52%',
    perDementia: '20%',
    perRelatedDementia: '28%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '10%',
    perGenetic: '41%',
    perModel: '36%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '17%',
    perAnimal: '16%',
    perHuman: '71%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 263,
    pathway: 'Renin-angiotensin system',
    totalNumberPapers: '710',
    adSpecificPaperCount: '404',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.85253',
    literatureRank: '64',
    adSpecificPaperRank: '78',
    prcPapersAd: '57%',
    perDementia: '15%',
    perRelatedDementia: '28%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '25%',
    perGenetic: '46%',
    perModel: '34%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '16%',
    perAnimal: '17%',
    perHuman: '72%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 264,
    pathway: 'Retinol metabolism',
    totalNumberPapers: '74',
    adSpecificPaperCount: '61',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.55405',
    literatureRank: '184',
    adSpecificPaperRank: '170',
    prcPapersAd: '82%',
    perDementia: '11%',
    perRelatedDementia: '5%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '22%',
    perGenetic: '27%',
    perModel: '45%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '24%',
    perAnimal: '27%',
    perHuman: '61%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 265,
    pathway: 'Retrograde endocannabinoid signaling',
    totalNumberPapers: '160',
    adSpecificPaperCount: '104',
    pathwayScore: 'high',
    adPathwayScore: '3.33333',
    adWordScore: '6.44375',
    literatureRank: '148',
    adSpecificPaperRank: '145',
    prcPapersAd: '65%',
    perDementia: '18%',
    perRelatedDementia: '16%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '11%',
    perModel: '73%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '11%',
    perAnimal: '37%',
    perHuman: '41%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 266,
    pathway: 'Rheumatoid arthritis',
    totalNumberPapers: '1069',
    adSpecificPaperCount: '440',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.92897',
    literatureRank: '47',
    adSpecificPaperRank: '70',
    prcPapersAd: '41%',
    perDementia: '44%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '44%',
    perGenetic: '35%',
    perModel: '31%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '28%',
    perAnimal: '13%',
    perHuman: '70%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 267,
    pathway: 'Riboflavin metabolism',
    totalNumberPapers: '25',
    adSpecificPaperCount: '15',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '5.96667',
    literatureRank: '210',
    adSpecificPaperRank: '205',
    prcPapersAd: '50%',
    perDementia: '23%',
    perRelatedDementia: '23%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '32%',
    perGenetic: '40%',
    perModel: '20%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '36%',
    perAnimal: '16%',
    perHuman: '76%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 268,
    pathway: 'Ribosome',
    totalNumberPapers: '254',
    adSpecificPaperCount: '189',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '8.17323',
    literatureRank: '119',
    adSpecificPaperRank: '110',
    prcPapersAd: '74%',
    perDementia: '9%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '25%',
    perModel: '57%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '6%',
    perAnimal: '31%',
    perHuman: '49%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 269,
    pathway: 'Ribosome biogenesis in eukaryotes',
    totalNumberPapers: '253',
    adSpecificPaperCount: '189',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '8.17323',
    literatureRank: '119',
    adSpecificPaperRank: '110',
    prcPapersAd: '74%',
    perDementia: '9%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '25%',
    perModel: '57%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '6%',
    perAnimal: '31%',
    perHuman: '49%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 270,
    pathway: 'RIG-I-like receptor signaling pathway',
    totalNumberPapers: '5',
    adSpecificPaperCount: '2',
    pathwayScore: 'high',
    adPathwayScore: '3.2',
    adWordScore: '5.8',
    literatureRank: '228',
    adSpecificPaperRank: '217',
    prcPapersAd: '40%',
    perDementia: '20%',
    perRelatedDementia: '20%',
    perUnrelatedDementia: '20%',
    perPapersUsingFullPathwayName: '40%',
    perGenetic: '43%',
    perModel: '29%',
    perBothModelGenetic: '29%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 271,
    pathway: 'RNA degradation',
    totalNumberPapers: '98',
    adSpecificPaperCount: '63',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '5.36364',
    literatureRank: '172',
    adSpecificPaperRank: '168',
    prcPapersAd: '64%',
    perDementia: '11%',
    perRelatedDementia: '22%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '51%',
    perModel: '31%',
    perBothModelGenetic: '17%',
    perNeitherModelGenetic: '1%',
    perAnimal: '21%',
    perHuman: '60%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 272,
    pathway: 'RNA polymerase',
    totalNumberPapers: '47',
    adSpecificPaperCount: '39',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '6.77083',
    literatureRank: '199',
    adSpecificPaperRank: '183',
    prcPapersAd: '81%',
    perDementia: '8%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '44%',
    perModel: '40%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '7%',
    perAnimal: '18%',
    perHuman: '53%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '20%'
  },
  {
    index: 273,
    pathway: 'RNA transport',
    totalNumberPapers: '46',
    adSpecificPaperCount: '26',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '5.82979',
    literatureRank: '200',
    adSpecificPaperRank: '195',
    prcPapersAd: '55%',
    perDementia: '2%',
    perRelatedDementia: '38%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '22%',
    perModel: '61%',
    perBothModelGenetic: '14%',
    perNeitherModelGenetic: '3%',
    perAnimal: '42%',
    perHuman: '31%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '25%'
  },
  {
    index: 274,
    pathway: 'Salivary secretion',
    totalNumberPapers: '52',
    adSpecificPaperCount: '29',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '3.88889',
    literatureRank: '196',
    adSpecificPaperRank: '192',
    prcPapersAd: '54%',
    perDementia: '30%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '16%',
    perModel: '32%',
    perBothModelGenetic: '2%',
    perNeitherModelGenetic: '50%',
    perAnimal: '11%',
    perHuman: '77%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '2%'
  },
  {
    index: 275,
    pathway: 'Salmonella infection',
    totalNumberPapers: '27',
    adSpecificPaperCount: '25',
    pathwayScore: 'low',
    adPathwayScore: '4',
    adWordScore: '5.21212',
    literatureRank: '208',
    adSpecificPaperRank: '196',
    prcPapersAd: '76%',
    perDementia: '15%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '28%',
    perModel: '55%',
    perBothModelGenetic: '17%',
    perNeitherModelGenetic: '0%',
    perAnimal: '41%',
    perHuman: '41%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 276,
    pathway: 'Selenocompound metabolism',
    totalNumberPapers: '208',
    adSpecificPaperCount: '155',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '8.34762',
    literatureRank: '131',
    adSpecificPaperRank: '118',
    prcPapersAd: '74%',
    perDementia: '18%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '18%',
    perModel: '56%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '21%',
    perAnimal: '31%',
    perHuman: '57%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 277,
    pathway: 'Serotonergic synapse',
    totalNumberPapers: '2157',
    adSpecificPaperCount: '1450',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '5.19926',
    literatureRank: '24',
    adSpecificPaperRank: '20',
    prcPapersAd: '67%',
    perDementia: '17%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '24%',
    perModel: '49%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '24%',
    perAnimal: '23%',
    perHuman: '64%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 278,
    pathway: 'Shigellosis',
    totalNumberPapers: '4',
    adSpecificPaperCount: '3',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '9.75',
    literatureRank: '231',
    adSpecificPaperRank: '216',
    prcPapersAd: '75%',
    perDementia: '25%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '50%',
    perModel: '25%',
    perBothModelGenetic: '25%',
    perNeitherModelGenetic: '0%',
    perAnimal: '0%',
    perHuman: '100%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 279,
    pathway: 'Signaling pathways regulating pluripotency of stem cells',
    totalNumberPapers: '515',
    adSpecificPaperCount: '346',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '7.69157',
    literatureRank: '78',
    adSpecificPaperRank: '86',
    prcPapersAd: '67%',
    perDementia: '16%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '7%',
    perGenetic: '10%',
    perModel: '77%',
    perBothModelGenetic: '11%',
    perNeitherModelGenetic: '2%',
    perAnimal: '37%',
    perHuman: '44%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 280,
    pathway: 'Small cell lung cancer',
    totalNumberPapers: '191',
    adSpecificPaperCount: '74',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '1.75773',
    literatureRank: '137',
    adSpecificPaperRank: '162',
    prcPapersAd: '38%',
    perDementia: '45%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '16%',
    perGenetic: '38%',
    perModel: '26%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '30%',
    perAnimal: '6%',
    perHuman: '69%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '18%'
  },
  {
    index: 281,
    pathway: 'SNARE interactions in vesicular transport',
    totalNumberPapers: '57',
    adSpecificPaperCount: '38',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '6.24561',
    literatureRank: '195',
    adSpecificPaperRank: '184',
    prcPapersAd: '67%',
    perDementia: '11%',
    perRelatedDementia: '23%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '15%',
    perModel: '64%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '13%',
    perAnimal: '34%',
    perHuman: '30%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '23%'
  },
  {
    index: 282,
    pathway: 'Sphingolipid metabolism',
    totalNumberPapers: '224',
    adSpecificPaperCount: '176',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '8.78571',
    literatureRank: '125',
    adSpecificPaperRank: '112',
    prcPapersAd: '79%',
    perDementia: '13%',
    perRelatedDementia: '5%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '50%',
    perGenetic: '17%',
    perModel: '65%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '12%',
    perAnimal: '24%',
    perHuman: '49%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '19%'
  },
  {
    index: 283,
    pathway: 'Sphingolipid signaling pathway',
    totalNumberPapers: '220',
    adSpecificPaperCount: '174',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '8.81818',
    literatureRank: '127',
    adSpecificPaperRank: '113',
    prcPapersAd: '79%',
    perDementia: '13%',
    perRelatedDementia: '4%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '24%',
    perGenetic: '16%',
    perModel: '65%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '12%',
    perAnimal: '25%',
    perHuman: '48%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '19%'
  },
  {
    index: 284,
    pathway: 'Spliceosome',
    totalNumberPapers: '321',
    adSpecificPaperCount: '212',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '7.90654',
    literatureRank: '105',
    adSpecificPaperRank: '105',
    prcPapersAd: '66%',
    perDementia: '9%',
    perRelatedDementia: '24%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '99%',
    perGenetic: '56%',
    perModel: '27%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '3%',
    perAnimal: '18%',
    perHuman: '60%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 285,
    pathway: 'Staphylococcus aureus infection',
    totalNumberPapers: '62',
    adSpecificPaperCount: '20',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '1.34848',
    literatureRank: '189',
    adSpecificPaperRank: '201',
    prcPapersAd: '30%',
    perDementia: '67%',
    perRelatedDementia: '3%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '92%',
    perGenetic: '40%',
    perModel: '24%',
    perBothModelGenetic: '2%',
    perNeitherModelGenetic: '35%',
    perAnimal: '9%',
    perHuman: '87%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 286,
    pathway: 'Starch and sucrose metabolism',
    totalNumberPapers: '119',
    adSpecificPaperCount: '89',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '7.50781',
    literatureRank: '160',
    adSpecificPaperRank: '154',
    prcPapersAd: '70%',
    perDementia: '17%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '17%',
    perModel: '66%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '10%',
    perAnimal: '47%',
    perHuman: '34%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 287,
    pathway: 'Steroid biosynthesis',
    totalNumberPapers: '875',
    adSpecificPaperCount: '506',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '5.4732',
    literatureRank: '55',
    adSpecificPaperRank: '61',
    prcPapersAd: '58%',
    perDementia: '28%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '27%',
    perGenetic: '20%',
    perModel: '51%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '23%',
    perAnimal: '24%',
    perHuman: '59%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 288,
    pathway: 'Steroid hormone biosynthesis',
    totalNumberPapers: '873',
    adSpecificPaperCount: '505',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '5.48',
    literatureRank: '56',
    adSpecificPaperRank: '62',
    prcPapersAd: '58%',
    perDementia: '28%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '3%',
    perGenetic: '20%',
    perModel: '51%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '23%',
    perAnimal: '24%',
    perHuman: '59%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 289,
    pathway: 'Sulfur metabolism',
    totalNumberPapers: '53',
    adSpecificPaperCount: '23',
    pathwayScore: 'ok',
    adPathwayScore: '4',
    adWordScore: '4.62963',
    literatureRank: '196',
    adSpecificPaperRank: '198',
    prcPapersAd: '43%',
    perDementia: '39%',
    perRelatedDementia: '19%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '38%',
    perModel: '33%',
    perBothModelGenetic: '15%',
    perNeitherModelGenetic: '13%',
    perAnimal: '21%',
    perHuman: '62%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 290,
    pathway: 'Sulfur relay system',
    totalNumberPapers: '50',
    adSpecificPaperCount: '44',
    pathwayScore: 'high',
    adPathwayScore: '5',
    adWordScore: '9.45098',
    literatureRank: '197',
    adSpecificPaperRank: '178',
    prcPapersAd: '86%',
    perDementia: '8%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '13%',
    perModel: '65%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '15%',
    perAnimal: '13%',
    perHuman: '40%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '35%'
  },
  {
    index: 291,
    pathway: 'Synaptic vesicle cycle',
    totalNumberPapers: '563',
    adSpecificPaperCount: '447',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '10.325',
    literatureRank: '74',
    adSpecificPaperRank: '67',
    prcPapersAd: '79%',
    perDementia: '6%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '3%',
    perGenetic: '12%',
    perModel: '74%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '7%',
    perAnimal: '37%',
    perHuman: '40%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '14%'
  },
  {
    index: 292,
    pathway: 'Synthesis and degradation of ketone bodies',
    totalNumberPapers: '216',
    adSpecificPaperCount: '152',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '7.09722',
    literatureRank: '130',
    adSpecificPaperRank: '120',
    prcPapersAd: '70%',
    perDementia: '21%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '13%',
    perModel: '55%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '27%',
    perAnimal: '27%',
    perHuman: '46%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '20%'
  },
  {
    index: 293,
    pathway: 'Systemic lupus erythematosus',
    totalNumberPapers: '213',
    adSpecificPaperCount: '63',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '2.51852',
    literatureRank: '130',
    adSpecificPaperRank: '168',
    prcPapersAd: '30%',
    perDementia: '48%',
    perRelatedDementia: '15%',
    perUnrelatedDementia: '7%',
    perPapersUsingFullPathwayName: '73%',
    perGenetic: '31%',
    perModel: '19%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '43%',
    perAnimal: '8%',
    perHuman: '84%',
    perBothHumanAnimal: '3%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 294,
    pathway: 'T cell receptor signaling pathway',
    totalNumberPapers: '641',
    adSpecificPaperCount: '392',
    pathwayScore: 'high',
    adPathwayScore: '3.66667',
    adWordScore: '7.99381',
    literatureRank: '71',
    adSpecificPaperRank: '79',
    prcPapersAd: '61%',
    perDementia: '18%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '13%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '17%',
    perModel: '61%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '12%',
    perAnimal: '29%',
    perHuman: '53%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 295,
    pathway: 'Taste transduction',
    totalNumberPapers: '172',
    adSpecificPaperCount: '87',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '5.47093',
    literatureRank: '143',
    adSpecificPaperRank: '156',
    prcPapersAd: '51%',
    perDementia: '34%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '2%',
    perGenetic: '23%',
    perModel: '36%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '36%',
    perAnimal: '20%',
    perHuman: '68%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 296,
    pathway: 'Taurine and hypotaurine metabolism',
    totalNumberPapers: '99',
    adSpecificPaperCount: '65',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '7.24242',
    literatureRank: '172',
    adSpecificPaperRank: '166',
    prcPapersAd: '66%',
    perDementia: '20%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '33%',
    perGenetic: '7%',
    perModel: '72%',
    perBothModelGenetic: '6%',
    perNeitherModelGenetic: '16%',
    perAnimal: '44%',
    perHuman: '38%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 297,
    pathway: 'Terpenoid backbone biosynthesis',
    totalNumberPapers: '146',
    adSpecificPaperCount: '101',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '6.36301',
    literatureRank: '152',
    adSpecificPaperRank: '146',
    prcPapersAd: '69%',
    perDementia: '21%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '15%',
    perModel: '58%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '21%',
    perAnimal: '27%',
    perHuman: '50%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 298,
    pathway: 'TGF-beta signaling pathway',
    totalNumberPapers: '492',
    adSpecificPaperCount: '373',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '10.1687',
    literatureRank: '81',
    adSpecificPaperRank: '83',
    prcPapersAd: '76%',
    perDementia: '9%',
    perRelatedDementia: '13%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '26%',
    perGenetic: '21%',
    perModel: '66%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '7%',
    perAnimal: '36%',
    perHuman: '45%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 299,
    pathway: 'Th1 and Th2 cell differentiation',
    totalNumberPapers: '186',
    adSpecificPaperCount: '155',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '13.4677',
    literatureRank: '139',
    adSpecificPaperRank: '118',
    prcPapersAd: '83%',
    perDementia: '11%',
    perRelatedDementia: '4%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '1%',
    perGenetic: '16%',
    perModel: '66%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '8%',
    perAnimal: '47%',
    perHuman: '33%',
    perBothHumanAnimal: '13%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 300,
    pathway: 'Th17 cell differentiation',
    totalNumberPapers: '28',
    adSpecificPaperCount: '16',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '9.71429',
    literatureRank: '212',
    adSpecificPaperRank: '204',
    prcPapersAd: '57%',
    perDementia: '29%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '11%',
    perGenetic: '14%',
    perModel: '71%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '5%',
    perAnimal: '48%',
    perHuman: '43%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 301,
    pathway: 'Thermogenesis',
    totalNumberPapers: '41',
    adSpecificPaperCount: '22',
    pathwayScore: 'high',
    adPathwayScore: '3.33333',
    adWordScore: '4.09524',
    literatureRank: '203',
    adSpecificPaperRank: '199',
    prcPapersAd: '52%',
    perDementia: '31%',
    perRelatedDementia: '17%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '10%',
    perModel: '63%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '17%',
    perAnimal: '40%',
    perHuman: '47%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 302,
    pathway: 'Thiamine metabolism',
    totalNumberPapers: '180',
    adSpecificPaperCount: '90',
    pathwayScore: 'good',
    adPathwayScore: '2',
    adWordScore: '4.53333',
    literatureRank: '140',
    adSpecificPaperRank: '153',
    prcPapersAd: '50%',
    perDementia: '37%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '35%',
    perGenetic: '23%',
    perModel: '44%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '30%',
    perAnimal: '18%',
    perHuman: '70%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '7%'
  },
  {
    index: 303,
    pathway: 'Thyroid cancer',
    totalNumberPapers: '15',
    adSpecificPaperCount: '9',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '5.0625',
    literatureRank: '221',
    adSpecificPaperRank: '211',
    prcPapersAd: '56%',
    perDementia: '44%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '50%',
    perModel: '25%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '25%',
    perAnimal: '0%',
    perHuman: '75%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '25%'
  },
  {
    index: 304,
    pathway: 'Thyroid hormone signaling pathway',
    totalNumberPapers: '307',
    adSpecificPaperCount: '146',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '5.38961',
    literatureRank: '106',
    adSpecificPaperRank: '123',
    prcPapersAd: '47%',
    perDementia: '38%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '5%',
    perGenetic: '28%',
    perModel: '23%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '45%',
    perAnimal: '10%',
    perHuman: '81%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 305,
    pathway: 'Thyroid hormone synthesis',
    totalNumberPapers: '309',
    adSpecificPaperCount: '149',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '5.39744',
    literatureRank: '106',
    adSpecificPaperRank: '122',
    prcPapersAd: '48%',
    perDementia: '38%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '12%',
    perGenetic: '28%',
    perModel: '23%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '45%',
    perAnimal: '10%',
    perHuman: '81%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 306,
    pathway: 'Tight junction',
    totalNumberPapers: '199',
    adSpecificPaperCount: '94',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '6.01005',
    literatureRank: '135',
    adSpecificPaperRank: '151',
    prcPapersAd: '48%',
    perDementia: '20%',
    perRelatedDementia: '29%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '5%',
    perModel: '81%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '10%',
    perAnimal: '32%',
    perHuman: '45%',
    perBothHumanAnimal: '11%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 307,
    pathway: 'TNF signaling pathway',
    totalNumberPapers: '2326',
    adSpecificPaperCount: '1678',
    pathwayScore: 'high',
    adPathwayScore: '2.5',
    adWordScore: '9.12038',
    literatureRank: '23',
    adSpecificPaperRank: '17',
    prcPapersAd: '72%',
    perDementia: '12%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '6%',
    perPapersUsingFullPathwayName: '18%',
    perGenetic: '13%',
    perModel: '73%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '10%',
    perAnimal: '41%',
    perHuman: '44%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 308,
    pathway: 'Toll-like receptor signaling pathway',
    totalNumberPapers: '331',
    adSpecificPaperCount: '260',
    pathwayScore: 'high',
    adPathwayScore: '2',
    adWordScore: '9.67976',
    literatureRank: '103',
    adSpecificPaperRank: '98',
    prcPapersAd: '79%',
    perDementia: '11%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '28%',
    perGenetic: '21%',
    perModel: '71%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '3%',
    perAnimal: '43%',
    perHuman: '36%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 309,
    pathway: 'Toxoplasmosis',
    totalNumberPapers: '145',
    adSpecificPaperCount: '21',
    pathwayScore: 'high',
    adPathwayScore: '4.5',
    adWordScore: '1.58108',
    literatureRank: '151',
    adSpecificPaperRank: '200',
    prcPapersAd: '14%',
    perDementia: '20%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '56%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '31%',
    perModel: '24%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '40%',
    perAnimal: '6%',
    perHuman: '86%',
    perBothHumanAnimal: '2%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 310,
    pathway: 'Transcriptional misregulation in cancer',
    totalNumberPapers: '306',
    adSpecificPaperCount: '207',
    pathwayScore: 'ok',
    adPathwayScore: '4.66667',
    adWordScore: '5.24919',
    literatureRank: '107',
    adSpecificPaperRank: '106',
    prcPapersAd: '67%',
    perDementia: '21%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '34%',
    perModel: '49%',
    perBothModelGenetic: '15%',
    perNeitherModelGenetic: '2%',
    perAnimal: '27%',
    perHuman: '50%',
    perBothHumanAnimal: '10%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 311,
    pathway: 'Tryptophan metabolism',
    totalNumberPapers: '452',
    adSpecificPaperCount: '297',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '5.3208',
    literatureRank: '87',
    adSpecificPaperRank: '94',
    prcPapersAd: '66%',
    perDementia: '19%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '42%',
    perGenetic: '18%',
    perModel: '49%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '28%',
    perAnimal: '25%',
    perHuman: '59%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '11%'
  },
  {
    index: 312,
    pathway: 'Tuberculosis',
    totalNumberPapers: '163',
    adSpecificPaperCount: '50',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '1.8869',
    literatureRank: '145',
    adSpecificPaperRank: '175',
    prcPapersAd: '30%',
    perDementia: '37%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '22%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '36%',
    perModel: '17%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '43%',
    perAnimal: '5%',
    perHuman: '82%',
    perBothHumanAnimal: '4%',
    perNeitherHumanAnimal: '9%'
  },
  {
    index: 313,
    pathway: 'Type I diabetes mellitus',
    totalNumberPapers: '209',
    adSpecificPaperCount: '98',
    pathwayScore: 'high',
    adPathwayScore: '2.66667',
    adWordScore: '6.74641',
    literatureRank: '132',
    adSpecificPaperRank: '148',
    prcPapersAd: '47%',
    perDementia: '28%',
    perRelatedDementia: '22%',
    perUnrelatedDementia: '3%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '46%',
    perModel: '42%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '8%',
    perAnimal: '25%',
    perHuman: '64%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '3%'
  },
  {
    index: 314,
    pathway: 'Type II diabetes mellitus',
    totalNumberPapers: '1905',
    adSpecificPaperCount: '1266',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.78163',
    literatureRank: '26',
    adSpecificPaperRank: '23',
    prcPapersAd: '66%',
    perDementia: '21%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '37%',
    perModel: '40%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '15%',
    perAnimal: '20%',
    perHuman: '62%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 315,
    pathway: 'Tyrosine metabolism',
    totalNumberPapers: '884',
    adSpecificPaperCount: '593',
    pathwayScore: 'good',
    adPathwayScore: '2.66667',
    adWordScore: '8.06222',
    literatureRank: '54',
    adSpecificPaperRank: '59',
    prcPapersAd: '67%',
    perDementia: '12%',
    perRelatedDementia: '19%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '12%',
    perModel: '75%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '7%',
    perAnimal: '39%',
    perHuman: '41%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 316,
    pathway: 'Ubiquinone and other terpenoid quinone biosynthesis',
    totalNumberPapers: '277',
    adSpecificPaperCount: '156',
    pathwayScore: 'good',
    adPathwayScore: '3',
    adWordScore: '6.65827',
    literatureRank: '111',
    adSpecificPaperRank: '117',
    prcPapersAd: '56%',
    perDementia: '21%',
    perRelatedDementia: '22%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '10%',
    perGenetic: '23%',
    perModel: '54%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '18%',
    perAnimal: '32%',
    perHuman: '47%',
    perBothHumanAnimal: '8%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 317,
    pathway: 'Ubiquitin mediated proteolysis',
    totalNumberPapers: '2068',
    adSpecificPaperCount: '1124',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '7.20648',
    literatureRank: '25',
    adSpecificPaperRank: '26',
    prcPapersAd: '54%',
    perDementia: '11%',
    perRelatedDementia: '34%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '32%',
    perGenetic: '27%',
    perModel: '55%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '9%',
    perAnimal: '21%',
    perHuman: '57%',
    perBothHumanAnimal: '6%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 318,
    pathway: 'Valine leucine and isoleucine biosynthesis',
    totalNumberPapers: '173',
    adSpecificPaperCount: '122',
    pathwayScore: 'ok',
    adPathwayScore: '2',
    adWordScore: '7.54857',
    literatureRank: '142',
    adSpecificPaperRank: '136',
    prcPapersAd: '70%',
    perDementia: '15%',
    perRelatedDementia: '11%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '35%',
    perModel: '42%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '16%',
    perAnimal: '27%',
    perHuman: '51%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 319,
    pathway: 'Valine leucine and isoleucine degradation',
    totalNumberPapers: '153',
    adSpecificPaperCount: '108',
    pathwayScore: 'ok',
    adPathwayScore: '3.5',
    adWordScore: '7.60131',
    literatureRank: '142',
    adSpecificPaperRank: '142',
    prcPapersAd: '71%',
    perDementia: '14%',
    perRelatedDementia: '10%',
    perUnrelatedDementia: '5%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '35%',
    perModel: '42%',
    perBothModelGenetic: '7%',
    perNeitherModelGenetic: '16%',
    perAnimal: '27%',
    perHuman: '51%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 320,
    pathway: 'Various types of N-glycan biosynthesis',
    totalNumberPapers: '103',
    adSpecificPaperCount: '85',
    pathwayScore: 'high',
    adPathwayScore: '3',
    adWordScore: '9.31731',
    literatureRank: '171',
    adSpecificPaperRank: '157',
    prcPapersAd: '83%',
    perDementia: '10%',
    perRelatedDementia: '6%',
    perUnrelatedDementia: '2%',
    perPapersUsingFullPathwayName: '9%',
    perGenetic: '34%',
    perModel: '42%',
    perBothModelGenetic: '9%',
    perNeitherModelGenetic: '15%',
    perAnimal: '19%',
    perHuman: '61%',
    perBothHumanAnimal: '5%',
    perNeitherHumanAnimal: '15%'
  },
  {
    index: 321,
    pathway: 'Vascular smooth muscle contraction',
    totalNumberPapers: '110',
    adSpecificPaperCount: '55',
    pathwayScore: 'good',
    adPathwayScore: '4.5',
    adWordScore: '8.1875',
    literatureRank: '166',
    adSpecificPaperRank: '173',
    prcPapersAd: '49%',
    perDementia: '4%',
    perRelatedDementia: '46%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '71%',
    perGenetic: '13%',
    perModel: '72%',
    perBothModelGenetic: '4%',
    perNeitherModelGenetic: '11%',
    perAnimal: '52%',
    perHuman: '39%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 322,
    pathway: 'Vasopressin-regulated water reabsorption',
    totalNumberPapers: '25',
    adSpecificPaperCount: '14',
    pathwayScore: 'good',
    adPathwayScore: '3.5',
    adWordScore: '6.36',
    literatureRank: '214',
    adSpecificPaperRank: '206',
    prcPapersAd: '56%',
    perDementia: '28%',
    perRelatedDementia: '12%',
    perUnrelatedDementia: '4%',
    perPapersUsingFullPathwayName: '8%',
    perGenetic: '14%',
    perModel: '62%',
    perBothModelGenetic: '10%',
    perNeitherModelGenetic: '14%',
    perAnimal: '62%',
    perHuman: '38%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '0%'
  },
  {
    index: 323,
    pathway: 'VEGF signaling pathway',
    totalNumberPapers: '346',
    adSpecificPaperCount: '144',
    pathwayScore: 'high',
    adPathwayScore: '1',
    adWordScore: '8.63295',
    literatureRank: '99',
    adSpecificPaperRank: '124',
    prcPapersAd: '42%',
    perDementia: '6%',
    perRelatedDementia: '53%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '15%',
    perGenetic: '19%',
    perModel: '63%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '15%',
    perAnimal: '33%',
    perHuman: '52%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '6%'
  },
  {
    index: 324,
    pathway: 'Vibrio cholerae infection',
    totalNumberPapers: '51',
    adSpecificPaperCount: '42',
    pathwayScore: 'high',
    adPathwayScore: '3.5',
    adWordScore: '11.6275',
    literatureRank: '197',
    adSpecificPaperRank: '180',
    prcPapersAd: '82%',
    perDementia: '10%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '16%',
    perModel: '80%',
    perBothModelGenetic: '0%',
    perNeitherModelGenetic: '4%',
    perAnimal: '37%',
    perHuman: '37%',
    perBothHumanAnimal: '14%',
    perNeitherHumanAnimal: '12%'
  },
  {
    index: 325,
    pathway: 'Viral carcinogenesis',
    totalNumberPapers: '21',
    adSpecificPaperCount: '16',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '3.84615',
    literatureRank: '213',
    adSpecificPaperRank: '204',
    prcPapersAd: '64%',
    perDementia: '12%',
    perRelatedDementia: '8%',
    perUnrelatedDementia: '16%',
    perPapersUsingFullPathwayName: '100%',
    perGenetic: '48%',
    perModel: '30%',
    perBothModelGenetic: '22%',
    perNeitherModelGenetic: '0%',
    perAnimal: '22%',
    perHuman: '48%',
    perBothHumanAnimal: '26%',
    perNeitherHumanAnimal: '4%'
  },
  {
    index: 326,
    pathway: 'Viral myocarditis',
    totalNumberPapers: '11',
    adSpecificPaperCount: '3',
    pathwayScore: 'high',
    adPathwayScore: '4',
    adWordScore: '0.818182',
    literatureRank: '220',
    adSpecificPaperRank: '216',
    prcPapersAd: '27%',
    perDementia: '36%',
    perRelatedDementia: '36%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '45%',
    perGenetic: '25%',
    perModel: '25%',
    perBothModelGenetic: '8%',
    perNeitherModelGenetic: '42%',
    perAnimal: '8%',
    perHuman: '83%',
    perBothHumanAnimal: '0%',
    perNeitherHumanAnimal: '8%'
  },
  {
    index: 327,
    pathway: 'Viral protein interaction with cytokine and cytokine receptor',
    totalNumberPapers: '333',
    adSpecificPaperCount: '116',
    pathwayScore: 'low',
    adPathwayScore: '4.5',
    adWordScore: '4.59701',
    literatureRank: '101',
    adSpecificPaperRank: '140',
    prcPapersAd: '35%',
    perDementia: '17%',
    perRelatedDementia: '9%',
    perUnrelatedDementia: '38%',
    perPapersUsingFullPathwayName: '17%',
    perGenetic: '13%',
    perModel: '66%',
    perBothModelGenetic: '12%',
    perNeitherModelGenetic: '8%',
    perAnimal: '22%',
    perHuman: '61%',
    perBothHumanAnimal: '12%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 328,
    pathway: 'Vitamin B6 metabolism',
    totalNumberPapers: '135',
    adSpecificPaperCount: '58',
    pathwayScore: 'good',
    adPathwayScore: '4',
    adWordScore: '6.75',
    literatureRank: '156',
    adSpecificPaperRank: '171',
    prcPapersAd: '43%',
    perDementia: '26%',
    perRelatedDementia: '30%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '37%',
    perGenetic: '50%',
    perModel: '22%',
    perBothModelGenetic: '3%',
    perNeitherModelGenetic: '25%',
    perAnimal: '12%',
    perHuman: '82%',
    perBothHumanAnimal: '2%',
    perNeitherHumanAnimal: '5%'
  },
  {
    index: 329,
    pathway: 'Vitamin digestion and absorption',
    totalNumberPapers: '128',
    adSpecificPaperCount: '44',
    pathwayScore: 'high',
    adPathwayScore: '3.66667',
    adWordScore: '2.96154',
    literatureRank: '159',
    adSpecificPaperRank: '178',
    prcPapersAd: '34%',
    perDementia: '44%',
    perRelatedDementia: '14%',
    perUnrelatedDementia: '9%',
    perPapersUsingFullPathwayName: '4%',
    perGenetic: '39%',
    perModel: '31%',
    perBothModelGenetic: '5%',
    perNeitherModelGenetic: '25%',
    perAnimal: '17%',
    perHuman: '64%',
    perBothHumanAnimal: '9%',
    perNeitherHumanAnimal: '10%'
  },
  {
    index: 330,
    pathway: 'Wnt signaling pathway',
    totalNumberPapers: '393',
    adSpecificPaperCount: '341',
    pathwayScore: 'high',
    adPathwayScore: '1.5',
    adWordScore: '8.40609',
    literatureRank: '95',
    adSpecificPaperRank: '88',
    prcPapersAd: '87%',
    perDementia: '6%',
    perRelatedDementia: '7%',
    perUnrelatedDementia: '1%',
    perPapersUsingFullPathwayName: '85%',
    perGenetic: '19%',
    perModel: '63%',
    perBothModelGenetic: '13%',
    perNeitherModelGenetic: '5%',
    perAnimal: '39%',
    perHuman: '40%',
    perBothHumanAnimal: '7%',
    perNeitherHumanAnimal: '13%'
  },
  {
    index: 331,
    pathway: 'Yersinia infection',
    totalNumberPapers: '0',
    adSpecificPaperCount: '0',
    pathwayScore: 'NA',
    adPathwayScore: 'NA',
    adWordScore: '0',
    literatureRank: '237',
    adSpecificPaperRank: '219',
    prcPapersAd: '0%',
    perDementia: '0%',
    perRelatedDementia: '0%',
    perUnrelatedDementia: '0%',
    perPapersUsingFullPathwayName: '0%',
    perGenetic: '-',
    perModel: '-',
    perBothModelGenetic: '-',
    perNeitherModelGenetic: '-',
    perAnimal: '-',
    perHuman: '-',
    perBothHumanAnimal: '-',
    perNeitherHumanAnimal: '-'
  }
]

export default Data